export default {
  serviceCenter: {
    abilityAbove07KnowledgePointCount: "能力值>0.7知识点数",
    abilityAtLeast085KnowledgePointCount: "能力值>=0.85知识点数",
    abilityAtMost07KnowledgePointCount: "能力值<=0.7知识点数",
    abilityAtMost085KnowledgePointCount: "能力值<=0.85知识点数",
    abilityImprovement: "能力值提升量",
    account: "智适应账号",
    accountActivateDate: "账户激活日期：",
    accountActivateTime: "账户激活时间",
    accountBalanceLabel: "账户余额：",
    accountBindDate: "账号绑定日期",
    accountBindLimitExceeded: "学习机不可再绑定更多账号，请解绑账号后重试",
    accountBindMachineTime: "注册时间：",
    accountBindMachineTimeTitle: "注册时间",
    accountBindPhone: "账号绑定手机号",
    accountBindTime: "账户绑定时间",
    accountCannotSubscribe: "当前账号不可订阅，请等待总部审核通过后再次尝试。",
    accountFaceUnbind: "此账号因人脸信息解绑，不可继续使用。",
    accountFreeze: "账户冻结",
    accountLabel: "账号",
    accountNotExist: "账号不存在",
    accountPausedCannotSubscribe: "当前账号已暂停不可订阅，请在家长通解绑多余账号或进行上限申请。",
    accountPhoneRebind: "账户手机号换绑",
    accountRequired: "账户不能为空",
    accountStatus: "账号状态",
    accountStatusLabel: "账户状态：",
    accountType: "账号类型",
    accountUnbind: "账号解绑",
    accountUnbindPhoneTip: "此账号末绑定手机号，无法更换服务中心。请先绑定手机号后再试。",
    accountUnfreeze: "账户解冻",
    accountUser: "用户账号",
    activate: "激活",
    machineStatusNoActive: "未激活",
    machineStatusActive: "已激活",
    activeStudentCount: "活跃学生数",
    activityEndTime: "活动结束时间",
    activityStartTime: "活动开始时间",
    activitySubject: "活动学科",
    adaptiveAccount: "智适应账号：",
    adaptiveAccountColon: "智适应账号：",
    adaptiveAccountLabel: "智适应账号：",
    adaptiveAccountText: "智适应账号",
    addFollowRecordTitle: "添加跟进记录",
    address: "地址",
    addSuccess: "添加成功",
    afterMailingPleaseGoTo: "2、邮寄后请在【服务中心】—【维修管理】—【",
    age: "年龄:",
    agent: "代理商ID",
    agentId: "代理商ID",
    agentId26: "代理商ID",
    agentID408: "代理商ID",
    agentId48: "代理商ID",
    agentIdLabel: "代理商ID:",
    agentLabel: "代理商",
    agentName: "代理商名称",
    agentName27: "代理商名称",
    agentName409: "代理商名称",
    agentName49: "代理商名称",
    agentNameLabel: "代理商名称:",
    all: "全部",
    already: "已开通",
    videoCallServiceLabel: '视频通话服务:',
    notActivatedStatus: '未开通',
    activatedStatus: '已开通',
    nextDeductTimeLabel: '下次扣费时间:',
    remainCallTimeLabel: '今日剩余通话时间:',
    cashAccountLabel: '现金账户：',
    dayUnit: '天',
    minutePerDayUnit: '分钟/天',
    analystName: "分析师姓名",
    analystReviewer1: "复盘人",
    analystReviewExport: "分析师复盘记录导出",
    analystReviewSyncCourseStudyLength: "同步课学习时长",
    analystWeeklyReport: "分析师服务指标周报",
    applicationLengthTip: "请填写2-50字",
    applicationNote: "申请说明",
    applicationNote41: "申请说明",
    applicationNoteLabel: "申请说明:",
    applyAccountSubscriptionAuth: "申请账户订阅授权",
    applyAuth: "申请授权",
    applyAuthConfirmTip: "确认后发起授权申请到家长通。",
    applyCheckFailed: "申请前校验失败",
    applyElectronicCert: "申请电子证书",
    applyPaperCert: "申请纸质证书",
    applySuccess: "申请成功",
    applyTime: "申请时间：",
    applyTipText: "仅展示未申请的学员，已申请或支付中的学员将不再展示；支付中的学员订单请至\"采购中心-线上订单\"处理",
    applyTransferServiceCenter: "申请转入服务中心",
    applyTransferSuccessTip: "用户{name}（{account}）已提交转入服务中心申请。<br /><br />请联系家长在松鼠Ai智能学习机家长通进行确认，如7天内家长未进行确认，转入服务中心失败，需重新提交申请",
    area: "所在区域",
    area267: "所在区域",
    areaBalance: "区域时长（赠送或续费）余额",
    areaBalanceLabel: "区域时长（赠送或续费）余额:",
    areaBalanceLabelShort: "区域时长:",
    areaBalanceMonthLabel: "区域时长（赠送或续费）月数:",
    areaBalanceMonthsLabel: "区域时长（赠送或续费）月数:",
    areaDuration25: "区域时长",
    areaDurationBalanceLabel: "区域时长余额:",
    audit: "审核人",
    auditOpinion: "审核意见",
    authorizationStatus: "授权状态",
    auto_0_3a534d59: "支付详情",
    auto_0_ce0535cf: "维修类别",
    auto_0_daf1dd54: "请选择实际处理方式",
    auto_067_7601e4b2: "报价说明:",
    auto_07_84b8cb39: "商品详情",
    auto_072_88aee664: "优惠金额",
    auto_1_0823eb8e: "请选择建议处理方式",
    auto_1_165d48be: "联系人1:",
    auto_1_30bb9873: "换绑校验未通过，请稍后重试",
    auto_1_9070e5ca: "序号",
    auto_1_af66dc5d: "订阅学科管理",
    auto_10_f6175120: "支付成功",
    auto_100_1d863d17: "请输入校区地址",
    auto_100_fba7f4c6: "离校全日制",
    auto_101_d439e55b: "备注",
    auto_101_e2aedd75: "操作时间",
    auto_102_26f2fe11: "请输入备注200字以内",
    auto_102_951961f3: "操作类型",
    auto_103_31b2b61a: "操作",
    auto_103_bd53e7e8: "操作人",
    auto_104_2faa36a6: "添加商品",
    auto_104_d8c791af: "金币数",
    goldCoinBalanceLabel: '金币余额：',
    auto_105_d0cf4135: "确认",
    auto_105_e9a92572: "备注",
    auto_106_4d6d84e4: "假日全日制",
    auto_107_1a3ae998: "离校全日制",
    auto_108_10a5fc1e: "务必要上传协议中的关键页",
    auto_109_75af8eab: "2全日制学习的开始和结束时间和填写不一致会被驳回",
    auto_11_2204ab70: "保存",
    auto_11_38b63b7f: "维修金额",
    auto_11_c0ec4324: "支付失败",
    auto_110_5f31333c: "申报有效期",
    auto_110_f60501a2: "张",
    auto_111_d4b3ffe4: "操作",
    auto_112_348a9ed7: "全日制类型",
    auto_113_eb7cefd1: "全日制起止日期",
    auto_114_ee10a1d6: "签署的全日制协议",
    auto_115_b799aa8a: "预览",
    auto_116_7aaa417f: "全部",
    auto_117_3cc991a0: "近半年",
    auto_118_c9074fd5: "近一年",
    auto_119_64538f3b: "阶段年级",
    auto_12_a5aabedb: "确定退订吗？",
    auto_12_b0263010: "服务中心",
    auto_120_7ac3b736: "课程",
    auto_1204_0527e8b9: "请选择故障分类",
    auto_121_4d27f7b6: "复制链接",
    auto_122_1e53b582: "查看报告",
    auto_123_7fd832fc: "阶段",
    auto_123_829cdda3: "手工打地基",
    auto_124_9ab01fc5: "系统打地基",
    auto_124_d08c864a: "请先选择阶段",
    auto_125_42965969: "非打地基",
    auto_125_f9c29978: "请选择课程",
    auto_126_833d3bf7: "视频通话服务未开通",
    auto_126_ac871dbb: "正式课",
    auto_127_96e51db7: "打地基降级",
    auto_127_da19ce81: "视频通话服务已开通",
    auto_128_f01e330d: "其他",
    auto_128_f729d6ba: "本次支付将扣除",
    auto_129_0d59f21f: "现金账户",
    auto_129_74e0f116: "正式课重学",
    auto_13_3e7b680b: "学习机账户管理",
    auto_13_c9216b74: "确定要撤回此次申请吗？",
    auto_130_7fe93f55: "剩余支付金额",
    auto_130_dc39f9ac: "打地基升级",
    auto_131_4c4eca8d: "打地基重学",
    auto_131_8d1457b5: "支付方式",
    auto_132_315490d7: "取消关闭视频通话服务",
    auto_132_b843f6aa: "分钟",
    auto_133_1c97f68c: "是否要开启自动续费开启后服务到期将会自动进行续费",
    auto_133_d5a9ecd5: "通话员工姓名",
    auto_134_caf9ef8b: "通话员工账号",
    auto_134_d87a1bfe: "关闭视频通话服务",
    auto_1345_4f27ef33: "实际处理方式:",
    auto_135_aa966d94: "是否需要关闭自动续费关闭后服务到期将不会自动续费",
    auto_135_c3004cf6: "拨打时间",
    auto_136_8b21a30d: "开通视频通话服务",
    auto_136_f63b4da6: "通话开始时间",
    auto_137_d7353e2e: "通话结束时间",
    auto_137_f04bdc99: "*请上传故障图片及确认需返厂的客服聊天记录，否则将不会被审核通过。",
    auto_138_06fe2370: "通话时长",
    auto_138_f9f1009e: "*您可在经销商小程序或经销商系统，找到客服入口与我们的客服沟通。",
    auto_139_54f25dde: "同意",
    auto_139_78a7474f: "小班",
    auto_14_3c96af6d: "确定解绑吗",
    auto_14_87909680: "服务中心账户管理",
    auto_140_0f33945c: "驳回",
    auto_141_49f1d688: "本地文件上传",
    auto_142_3028f9de: "拍摄图片/视频",
    auto_143_3ffe7afc: "返修单号",
    auto_144_25b3044c: "请输入设备SN",
    auto_145_51359635: "商品类型",
    auto_146_f1fd1dab: "首次硬件激活时间",
    auto_147_4e09be31: "硬件激活时间",
    auto_148_ff67d8df: "软件激活时间",
    auto_149_e5e59bbf: "经销商信息",
    auto_15_306787ed: "确定解绑吗",
    auto_15_35381be3: "取消退订",
    auto_150_8216ecc6: "上次维修时间",
    auto_151_1f7b6981: "换新有效时间",
    auto_152_2a3d0b25: "发货时间",
    auto_153_285a56ac: "保修有效时间",
    auto_154_ca0155a1: "预估故障分类",
    auto_155_ae7b9eab: "请选择预估故障分类",
    auto_156_01e9401f: "详细说明",
    auto_156_87c3f69b: "操作时间",
    auto_157_209fc4d7: "督学状态",
    auto_157_f63eef9f: "请输入详细说明400字以内",
    auto_158_1ae39484: "分析师",
    auto_158_277fad1a: "上传图片视频",
    auto_159_2e809b36: "督学开始",
    auto_159_c5f35bbc: "初诊处理方式",
    auto_16_c75582a9: "退订",
    auto_16_fc574e73: "操作",
    auto_160_0fd0f923: "初诊处理方式",
    auto_160_b408bfc4: "督学结束",
    auto_161_0e7074d3: "初诊处理方式",
    auto_161_b49a624a: "操作人",
    auto_162_2f0acc05: "备注",
    auto_162_31a2cef4: "初诊处理方式",
    auto_163_2f65a87d: "维修申请创建",
    auto_163_c4fff688: "初诊处理方式",
    auto_164_53e12b78: "初诊处理方式",
    auto_164_b1ee144c: "维修申请修改",
    auto_165_23adb576: "新SN码",
    auto_165_9314da58: "维修申请审核",
    auto_166_c174c9ae: "请输入新SN码",
    auto_166_d7b2c0e5: "维修申请返厂快递",
    auto_167_135f0459: "实际处理方式:",
    auto_167_e572d148: "维修申请维修结果",
    auto_168_09e3182c: "请选择实际处理方式",
    auto_168_60062016: "维修申请详情",
    auto_169_16249d57: "维修申请初诊",
    auto_169_82c84a87: "快递公司",
    auto_17_019f198f: "订阅学科管理",
    auto_17_f2e61b71: "订阅",
    auto_170_1f52a8fc: "维修申请质检",
    auto_170_b564cbf5: "请选择快递公司",
    auto_171_285012b1: "快递单号",
    auto_171_66f61756: "维修申请回寄快递",
    auto_172_a9b0d47b: "请输入快递单号",
    auto_172_d902028a: "维修申请复检结果",
    auto_173_10a54dad: "维修申请争议结果",
    auto_173_e2ab3dbb: "回寄结果",
    auto_174_24572297: "回寄图片视频",
    auto_174_809ab92b: "维修申请检测",
    auto_175_4b33805e: "复检备注",
    auto_175_f63053de: "维修申请填写报价单",
    auto_176_47f30660: "请输入备注400字以内",
    auto_176_98a3a89c: "维修申请维修支付",
    auto_177_5b24c14c: "采购单号",
    auto_177_eb22414a: "上传图片视频",
    auto_178_21da1dc7: "设备",
    auto_178_a2a89126: "故障设备寄件信息:",
    auto_179_8fedbfef: "维修完成后设备寄回地址:",
    auto_179_ea268695: "复检结果",
    auto_18_09bd5a0c: "订阅确认",
    auto_18_bf0e2367: "学员账号",
    auto_180_81a0f685: "售后处理方式:",
    auto_180_b0944925: "争议结果",
    auto_181_8d94fe0c: "维修厂商:",
    auto_181_fb5da079: "通过",
    auto_182_210ff69d: "正常",
    auto_182_dc5a4269: "厂商收件地址:",
    auto_183_7d26588a: "快递公司:",
    auto_183_fa970116: "不通过",
    auto_184_147c7ae0: "不良",
    auto_184_4833177f: "请选择快递公司",
    auto_185_9217b812: "维修申请创建",
    auto_185_9a01a66f: "快递单号",
    auto_185800506_58c5517a: "日志统计开始时间：2022年3月10日 18:58:00",
    auto_185800514_285eb524: "日志统计开始时间2022年3月10日",
    auto_186_63c16dc2: "请输入快递单号",
    auto_186_b8cb9234: "维修申请修改",
    auto_187_9b32ddbc: "设备回寄收件人姓名:",
    auto_187_dcb316c0: "维修申请审核",
    auto_188_38add320: "维修申请返厂快递",
    auto_188_fbfd4735: "请输入设备回寄收件人姓名",
    auto_189_8f2748d7: "维修申请维修结果",
    auto_189_f1c2c6f8: "设备回寄收件人手机号:",
    auto_19_057b7f8e: "取消订阅",
    auto_19_5502194f: "学员姓名",
    auto_190_02e41171: "维修申请详情",
    auto_190_5dc58112: "请输入设备回寄收件人手机号",
    auto_191_0e819a56: "地址过于简略请详细填:",
    auto_191_a87f2af7: "设备回寄收件地址:",
    auto_192_47a2745e: "暂无数据",
    auto_192_6864fd19: "请选择省市区",
    auto_193_04ebeeef: "xx省xx市xx区xx街道xx号",
    auto_194_0b4ed967: "给家长的处理方式:",
    auto_195_04d273c0: "请选择售后方式",
    auto_195_33d0c0b0: "采购单号",
    auto_196_50634837: "设备SN：",
    auto_196_af1d4694: "给家长的新机SN码:",
    auto_197_58238cdc: "请输入新机SN码",
    auto_198_d201175c: "阅读故障说明",
    auto_199_058a9250: "同意",
    auto_2_037c31fd: "请选择建议处理方式",
    auto_2_1c595e87: "解绑",
    auto_2_20f54b4b: "填写结果:",
    auto_2_34b654fd: "确认",
    auto_2_845314ef: "SN码:",
    auto_2_905c20d8: "更换手机号校验失败，请稍后重试",
    auto_2_ab5a3c71: "联系人2:",
    auto_20_1169bd4a: "本次订阅学科：",
    auto_20_87832da3: "服务中心ID",
    auto_200_eab01883: "驳回",
    auto_201_cc0c52e0: "本地文件上传",
    auto_20160_ba633b06: "同意",
    auto_202_cfbe45e7: "拍摄图片视频",
    auto_203_47c45527: "建议处理方式:",
    auto_203_959b08b8: "请选择评分",
    auto_204_38baf24a: "非常不满意",
    auto_204_c403a5e0: "请选择建议处理方式",
    auto_205_a42c243e: "不满意",
    auto_205_d8e5327e: "初诊处理方式",
    auto_206_317e891f: "一般",
    auto_206_802db140: "请选初诊处理方式",
    auto_207_73349dba: "实际处理方式",
    auto_207_a2abe9ff: "满意",
    auto_208_7f46aae8: "请选实际处理方式",
    auto_208_bf9129ea: "非常满意",
    auto_209_1ad3f865: "期待您的宝贵建议我们",
    auto_209_7a3032f3: "请选实际处理方式",
    auto_21_92f76fe3: "服务中心名称",
    auto_21_d819bfd8: "本次退订学科：",
    auto_210_c7bb407f: "实际故障类型:",
    auto_210000513_5078ee96: "日志统计开始时间2022年11月21日",
    auto_211_9123b491: "请选择故障分类",
    auto_212_03d121d3: "得分情况",
    auto_212_71196810: "检测说明",
    auto_213_c905215d: "请输入检测结果400字以内",
    auto_214_788c4e7e: "检测结果",
    auto_215_a3a60d9e: "检测图片视频",
    auto_216_fda9439e: "上传图片视频",
    auto_217_0b79ebf8: "阅读故障说明",
    auto_218_bde87180: "同意",
    auto_219_0d425989: "驳回",
    auto_22_71a84be6: "学习机账户",
    auto_22_ca836920: "本次扣除订阅时长：",
    auto_221_4fe609e4: "本地文件上传",
    auto_222_a26baab5: "拍摄图片视频",
    auto_223_0fdb1e9c: "建议处理方式",
    auto_224_6d36bd59: "请选择建议处理方式",
    auto_225_eac1b90f: "初诊处理方式",
    auto_226_281830e2: "请选择初诊处理方式",
    auto_227_4de236d6: "初诊说明",
    auto_227_79173d00: "英语",
    auto_228_9e8950ed: "数学",
    auto_228_a0a2b7b5: "请输入初诊说明400字以内",
    auto_229_06438c2d: "语文",
    auto_229_623ff621: "，重新获取",
    auto_229_b388a4cb: "初诊结果",
    auto_23_5eccdf82: "学习区域",
    auto_23_67c3b1f5: "本次返还订阅时长：",
    auto_230_4952764d: "学科",
    auto_230_79138e95: "预计完成时间",
    auto_231_6b85c456: "春期末考",
    auto_231_89c25eb2: "初诊图片视频",
    auto_232_0ecfdfec: "返厂快递信息",
    auto_232_cbe7d02c: "秋期中考",
    auto_233_410a70dc: "上传图片视频",
    auto_233_4fc7a003: "提分",
    auto_234_3cfbcbdf: "给家长的处理方式:",
    auto_234_6c77e952: "打基础总有效时长",
    auto_234_b92bb886: "保存",
    auto_235_8a4c4bb7: "排名",
    auto_235_df8798a9: "请选择售后方式",
    auto_236_74a41eaf: "得分",
    auto_236_b492118c: "给家长的新机SN码:",
    auto_237_60e436d2: "请输入新机SN码",
    auto_237_bddc5b89: "学科",
    auto_238_88c9b290: "建议处理方式",
    auto_238_8aa4d192: "打基础有效时长",
    auto_239_2011eb2e: "通关情况",
    auto_239_572dbdf7: "请选择建议处理方式",
    auto_24_be4e3997: "通用可用学习时长",
    auto_24_cfa4dd68: "月",
    auto_240_107ef516: "实际处理方式",
    auto_240_6e635316: "表现分",
    auto_241_a7c191fd: "数值",
    auto_241_c0807481: "请选择实际处理方式",
    auto_242_35bd356d: "得分",
    auto_242_a36f8021: "SN码:",
    auto_243_e3477f5f: "请输入SN码",
    auto_243_ffa5de49: "小时",
    auto_244_4144d920: "小时",
    auto_244_8afebfce: "维修金额原价",
    auto_245_b99f79ba: "优惠金额",
    auto_245_e36e402a: "已通关",
    auto_246_721fbde9: "未通关",
    auto_246_762a0a77: "维修金额合计",
    auto_247_24d7527d: "维修报价单下载",
    auto_247_cc41d671: "答题数量",
    auto_248_1ee0cfc4: "满分分",
    auto_248_ee3fba3a: "支付",
    auto_249_780e6b9b: "驳回",
    auto_249_87dcabb7: "正确率",
    auto_25_863b5b8e: "区域时长",
    auto_250_1ca1a70f: "拒修退回",
    auto_250_4ace5df9: "满分分",
    auto_251_31b81bd5: "打基础通关进度",
    auto_251_7ce21dc7: "如果您对维修报价结果有异议请及时联系客服人员选择拒修后设备会",
    auto_252_30e634c3: "微信支付二维码有效期是2小时如果二维码过期请重新点击支付获取",
    auto_252_5bb13c93: "满分分",
    auto_253_08309e32: "推荐使用微信支付",
    auto_253_3b43b9b0: "找不到海报容器元素",
    auto_254_8a43e66e: "生成图片失败",
    auto_254_cd68e88a: "支持信用卡支付",
    auto_255_8cc3a952: "客户姓名",
    auto_255_90e9650e: "使用微信支付",
    auto_256_e05908ce: "如果二维码已过期，请点击",
    auto_256_fb9dab74: "手机号",
    auto_257_b27d66fa: "刷新",
    auto_258_881fdc8a: "实名认证",
    auto_258_bb6cd229: "重新获取",
    auto_259_9c2853a7: "建议处理方式",
    auto_26_c4eea0dc: "代理商ID",
    auto_260_1fa1dfa2: "请选择建议处理方式",
    auto_261_6e4da30e: "实际处理方式",
    auto_261_8ab57ee8: "学段年级",
    auto_262_06dc2702: "请选择实际处理方式",
    auto_263_13c93438: "实际故障类型",
    auto_263_bc2c70c1: "通行证状态",
    auto_264_513d1204: "请选择故障分类",
    auto_264_588a1075: "同步课状态",
    auto_265_33c813d7: "服务人员",
    auto_265_f08753b4: "非保修原因:",
    auto_266_5bf5f7c5: "请选择非保修原因",
    auto_266_b63501b3: "学习机账号",
    auto_267_9f460522: "维修说明",
    auto_267_b97ad3f6: "所在区域",
    auto_268_88e2a405: "订阅学科",
    auto_268_939e0a95: "序号",
    auto_269_7a7810c0: "维修类别",
    auto_27_b61fc526: "说明",
    auto_27_d2bf4fe8: "代理商名称",
    auto_270_866f0b5a: "维修明细",
    auto_2702_84722670: "请选择实际处理方式",
    auto_271_00597f11: "维修金额",
    auto_272_b34f6e2c: "维修金额",
    auto_273_52546a8d: "支付说明:",
    auto_274_d28a4ee8: "请输入支付说明400字以内",
    auto_275_4945136b: "支付结果:",
    auto_276_b6d570db: "付款",
    auto_277_c6c3e0e3: "同意",
    auto_278_4d987287: "驳回",
    auto_279_0c5e2bee: "本地文件上传",
    auto_28_c95c1bcf: "科目",
    auto_280_a435f985: "拍摄图片视频",
    auto_281_90a430ff: "数学",
    auto_281_d8d42434: "实际处理方式",
    auto_282_12e37cb8: "请选实际处理方式",
    auto_282_20150756: "未持有",
    auto_283_a0c37874: "检测图片视频",
    auto_283_e9cbeeea: "已持有",
    auto_284_493a8502: "质检结果",
    auto_284_f3168d65: "临时通行证",
    auto_285_e93fb901: "可学（不推荐）",
    auto_285_fffa3009: "质检备注",
    auto_286_1b5ad69d: "请输入质检备注400字以内",
    auto_286_f3878e5a: "可学",
    auto_287_3425dcf8: "质检图片视频",
    auto_287_4ec7765a: "不可学",
    auto_288_0278db73: "邀请转入",
    auto_288_acbdb7f8: "上传图片视频",
    auto_289_7cb946ef: "请添加维修明细",
    auto_29_13d755f8: "学习机订阅状态",
    auto_292_544a569b: "阅读故障说明",
    auto_294_bccbd499: "阶段年级",
    auto_298_9b7d5cf3: "实际处理方式",
    auto_299_6bf44d2b: "请选择实际处理方式",
    auto_3_3c8a512d: "更换手机号校验失败，请稍后重试",
    auto_3_5e466813: "可用订阅时长≤3",
    auto_3_7cdf040b: "备注",
    auto_3_7ef232fe: "提交资料",
    auto_3_a4526aa1:
      "*微信支付二维码有效期是2小时，如果二维码过期，请重新点击「支付」获取二维码",
    auto_3_f3a61608: "联系人3:",
    auto_30_66c32371: "请选择代理商",
    auto_30_6dc1caf9: "最近订阅/取消订阅日期",
    auto_300_15efe189: "实际故障类型",
    auto_301_c4f93f5e: "请选择故障分类",
    auto_302_7e3fa6d5: "非保修原因",
    auto_303_55d157e8: "阶段年级",
    auto_305_05bf4e85: "服务人员",
    auto_31_6c5829a0: "当前学习截止日期",
    auto_31_fb14aa99: "商品名称",
    auto_316_5747370f: "维修说明:",
    auto_317_c4d8c876: "*请上传故障图片及确认需返厂的客服聊天记录，否则将不会被审核通过。",
    auto_318_e5664070: "*您可在经销商小程序或经销商系统，找到客服入口与我们的客服沟通。",
    auto_319_ca8fd6e8: "同意",
    auto_32_5300778b: "推荐使用微信支付",
    auto_32_b73ee84e: "单价",
    auto_32_de56ac7d: "操作",
    auto_320_9a8115d0: "驳回",
    auto_321_f3f42745: "返修单号：",
    auto_322_f62ecded: "请输入设备SN/采购单号",
    auto_323_21724802: "商品类型：",
    auto_324_1079117f: "首次硬件激活时间：",
    auto_325_1cd0fb06: "硬件激活时间：",
    auto_326_4dcbe91d: "软件激活时间：",
    auto_327_af652602: "经销商信息：",
    auto_328_455fdaa4: "上次维修时间：",
    auto_329_f6b5c503: "换新有效时间：",
    auto_33_1fd9eecb: "数量",
    auto_33_a236e8ce: "提交资料",
    auto_330_e440e0ab: "发货时间：",
    auto_331_00f8b802: "保修有效时间：",
    auto_332_0c473955: "预估故障分类：",
    auto_333_0ac5f60b: "近180天打地基有效时长(小时)",
    auto_333_d5c04f90: "请选择预估故障分类",
    auto_334_78609b66: "详细说明：",
    auto_334_b6f21e2a: "近180天打地基攻克知识漏洞数",
    auto_335_a582cb25: "学员近180天提分效果",
    auto_335_e921ea31: "请输入详细说明，400字以内",
    auto_336_c0d5b479: "上传图片/视频：",
    auto_336_fb423e6d: "近180天首次考试成绩",
    auto_337_1f51f868: "审核结果：",
    auto_337_6fc65c2a: "近180天最近一次考试成绩",
    auto_338_2f7b8451: "近180天首尾考试提分数",
    auto_338_7d752935: "返修厂商：",
    auto_339_31f360f4: "近180天平均提分数",
    auto_339_8572df53: "请选择申请类型",
    auto_34_a3e39357: "学习机账户",
    auto_34_c7372f4b: "金额",
    auto_340_0b74be28: "建议处理方式:",
    auto_340_5a440d46: "学员近180天成绩稳定性",
    auto_341_4b651596: "近180天考试平均分",
    auto_341_8d46ee87: "请选择建议处理方式:",
    auto_342_225d514e: "近180天成绩标准差",
    auto_342_d35a428e: "审核备注:",
    auto_343_57dbe80e: "请输入审核备注，400字以内",
    auto_344_bb55a52a: "同意",
    auto_345_0957f1aa: "驳回",
    auto_346_0908e2d5: "本地文件上传",
    auto_347_15d41886: "拍摄图片视频",
    auto_348_f9768426: "实际处理方式",
    auto_349_cc32882e: "请选实际处理方式",
    auto_35_06c71e3d: "经销商ID",
    auto_35_940b0b37: "支付流水号",
    auto_350_f2fc58e4: "实际故障类型",
    auto_351_0e2c4c06: "请选择故障分类",
    auto_351_c6b73e7a: "建议处理方式:",
    auto_352_98d4b1ac: "回寄结果",
    auto_353_0a993491: "快递公司",
    auto_354_199b57b5: "请选择快递公司",
    auto_355_e23b1694: "快递单号",
    auto_356_19d6bce9: "请输入快递单号",
    auto_357_7d0cefcc: "回寄图片视频",
    auto_358_85225a33: "上传图片视频",
    auto_359_47a2c2df: "维修金额原价",
    auto_36_7fe79402: "经销商名称",
    auto_36_8ef52a37: "支付方式",
    auto_36_abfdc9c9: "维修结果:",
    auto_360_ddcd3bef: "优惠金额",
    auto_361_b53ab372: "维修金额合计",
    auto_362_2f99307c: "维修报价单下载",
    auto_363_1fa20160: "同意",
    auto_364_3892d1b5: "驳回",
    auto_365_22d8e02c: "建议处理方式",
    auto_366_dc6be558: "请选择建议处理方式",
    auto_367_9e5d1345: "实际处理方式",
    auto_368_99d9acb0: "请选择实际处理方式",
    auto_369_2de8cffa: "实际故障类型",
    auto_37_b298f65c: "支付时间",
    auto_37_efc28e26: "学员账号",
    auto_370_cd112b3f: "请选择故障分类",
    auto_371_a50c5719: "非保修原因",
    auto_372_430d63b6: "请选择非保修原因",
    auto_372_9a3c1d7d: "维修金额合计",
    auto_373_9334412f: "SN码",
    auto_374_48ca1fa7: "请输入SN码",
    auto_375_bc903cbb: "维修明细",
    auto_376_21af678e: "数学",
    auto_376_e8e7b1b1: "序号",
    auto_377_4bc8c6b9: "全部",
    auto_377_51e94756: "维修类别",
    auto_378_087b51d3: "学生学习时长日报",
    auto_378_c18dccdf: "维修明细",
    auto_379_3295bba5: "维修金额",
    auto_38_5dc15e20: "学员姓名",
    auto_38_7c7db366: "支付金额",
    auto_380_0eae7322: "数学",
    auto_380_6326e534: "维修金额",
    auto_381_769fd351: "建议处理方式",
    auto_381_881fe582: "全部",
    auto_382_10ff1bd1: "请选择建议处理方式",
    auto_382_53fb76b8: "学生学习时长周报",
    auto_383_8ba4344d: "实际处理方式",
    auto_383_e6592468: "不限",
    auto_384_d0647bff: "请选择实际处理方式",
    auto_385_e8918b8d: "实际故障类型",
    auto_386_0f690b76: "请选择故障分类",
    auto_387_a572d6f2: "SN码",
    auto_388_86557d8e: "请输入SN码",
    auto_389_106ff316: "维修说明",
    auto_39_981a562a: "服务中心ID",
    auto_39_f8adeb50: "操作人",
    auto_390_f010e885: "请输入维修说明400字以内",
    auto_391_257f1d36: "维修结果",
    auto_4_1affe025: "非保修原因:",
    auto_4_848fbce8: "撤回申请",
    auto_40_616e090e: "发货日期",
    auto_40_71354afd: "服务中心名称",
    auto_403_cfdb95d6: "科目",
    auto_404_df63901a: "学习机订阅状态",
    auto_405_d42d266b: "当前截止日期",
    auto_406_8bcdf4a4: "重要提醒:为了确保全年级成绩能够统一、公正地进行计算和比较，在统计近180天的平均提分数、近180天考试平均分以及近180天的成绩标准差之前，我们将对每位学员的考试成绩进行标准化的转换处理，使其统一为100分制。",
    auto_407_aa45471f: "学员提分效果整体分析",
    auto_408_85cbea7f: "收起",
    auto_409_c74e2fe2: "展开",
    auto_41_9920dff0: "申请说明",
    auto_41_f852f988: "快递公司",
    auto_410_8f7838e4: "重要提醒:为了确保全年级成绩能够统一、公正地进行计算和比较，在统计近180天的平均提分数、近180天考试平均分以及近180天的成绩标准差之前，我们将对每位学员的考试成绩进行标准化的转换处理，使其统一为100分制。",
    auto_411_f630a136: "维修报价单",
    auto_412_fd56053a: "服务人员姓名",
    auto_413_f7669bb3: "最后编辑时间",
    auto_414_057d9acb: "最后编辑人",
    auto_415_22dcce77: "请先设置查询条件",
    auto_42_bdc73ed5: "快递单号",
    auto_42_db2651d9: "新学员姓名",
    auto_426_67419378: "暂无快递信息",
    auto_427_942e6019: "通行证",
    auto_428_d0383398: "长期",
    auto_429_91696a48: "总得分",
    auto_429_92e861db: "短期",
    auto_43_3ae78086: "物流状态",
    auto_43_ff2ef6b5: "新学员人脸照片",
    auto_430_6ca0eb76: "各学科总提分",
    auto_430_947eb541: "长期",
    auto_431_0bdf2f07: "打基础",
    auto_431_4c90514a: "短期",
    auto_432_68944296: "有效时长分",
    auto_432_e0aaf07a: "报告",
    auto_433_72267377: "报告",
    auto_433_9a2d44cd: "系统表现分",
    auto_434_99402a59: "学科提分情况满分100分",
    auto_434_edc2c553: "轨迹",
    auto_435_fbe7801b: "轨迹",
    auto_435_fd6be6e4: "跨学段补偿系数1225秋期中考是补偿后得分",
    auto_436_69c3e358: "通行证",
    auto_436_e6d00004: "学科打基础时长60小时",
    auto_437_27cd212a: "提分成绩不计入最终的排名计算",
    auto_437_ad9a62b2: "页大小前端先写死实际",
    auto_438_62acb843: "加载失败",
    auto_438_bba362ca: "打基础有效时长分满分100分",
    auto_439_934cfbdf: "统计周期2025年7月10日8月31日",
    auto_439_f1a47351: "语文",
    auto_44_22854a73: "证明材料",
    auto_44_2fde8375: "发货数量",
    auto_440_2d7949dd: "英语",
    auto_440_e470f698: "系统表现分满分20分",
    auto_441_33ffd6ef: "语文",
    auto_441_638f0ef4: "统计周期2025年7月10日8月31日",
    auto_442_6f7a8f7e: "英语",
    auto_442_cc42a56e: "无排名",
    auto_443_44dd07d6: "很遗憾在本次活动期间25年7月10日8月31日并没有进行打基",
    auto_443_ba4c8a8b: "次学习",
    auto_444_2f090940: "赠送",
    auto_45_0070c41a: "学员账号",
    auto_45_fff8ea33: "收费项目",
    auto_452_0ffc43ee: "服务时长",
    auto_453_5d03913f: "通话时长",
    auto_454_c079befc: "服务时长",
    auto_455_c641fa42: "通话时长",
    auto_456_f0368aa0: "现金账户",
    auto_457_055f7a2e: "剩余支付金额",
    auto_458_256c6775: "支付方式",
    auto_459_edcab6b9: "申请转入服务中心",
    auto_46_5e69feaa: "单价",
    auto_46_c38e83ce: "学员姓名",
    auto_460_635091c6: "智适应账号",
    auto_460522_c46627d1: "维修说明",
    auto_461_42ffa4f6: "请输入智适应账号",
    auto_462_77ac7212: "用户姓名",
    auto_463_866ca1be: "现服务中心ID",
    auto_464_b6bc3e36: "现服务中心名称",
    auto_465_e4f28096: "新机SN码",
    auto_466_417ab7f4: "初诊图片视频",
    auto_467_212fe736: "检测图片视频",
    auto_468_70d1a468: "质检图片视频",
    auto_469_6e3e8cfa: "回寄图片视频",
    auto_47_3f310da6: "学习机账户",
    auto_47_702b7486: "数量",
    auto_470_b4b3c003: "支付二维码有效期是2小时如果过期请联系经销商或者客服重新下载",
    auto_471_ce1859e8: "客户ID",
    auto_472_e66c9649: "1请在2个工作日内支付否则原机将认为不维修原机不修返回",
    auto_473_6a6a65c2: "2由于缺件或尽全力尚不能修复时将退回原维修款但不承担其他责任",
    auto_474_919d675a: "3维修好机器自通知之日起我维修中心为您免费保管1个月逾期不取",
    auto_475_0bccafc0: "保外维修需要收取维修费用请您在服务中心维修管理",
    auto_476_e3048df8: "维修支付",
    auto_477_231a7700: "需要进行保外维修由于保外维修需要收取维修费用请您在服务中心一",
    auto_478_d99e06c9: "修管理一",
    auto_479_7f349b2d: "维修支付",
    auto_48_76602ef3: "金额",
    auto_48_9304b4af: "代理商ID",
    auto_480_828e6717: "1、整机换新：需要将整套机器（机器、所有配件以及包材）一起寄回。如漏寄了配件，需要重新寄出，对应的快递费需要您自行承担。",
    auto_481_a786a76b: "2、快递要求：在正常质保内的机器请顺丰到付（选择基础保价1000），不接受顺丰以外的到付，如寄了其他快递公司的到付，费用将需您自行承担。",
    auto_482_e92ab4dc: "3、返厂的机器或配件请包装好，避免中途损坏，如因包装不符合，造成物品损坏自行付费维修。",
    auto_483_928fe8ab: "1请您及时邮寄设备给售后中心信息如下",
    auto_484_966e41e2: "2邮寄后请在服务中心维修管理",
    auto_485_ab50f737: "返厂快递",
    auto_486_d6b480e5: "您对本次维修服务满意吗",
    auto_487_007ca415: "提交",
    auto_488_b29e261f: "评价",
    auto_489_ddfa90d4: "已报名学员名单",
    auto_49_2585ba0c: "优惠金额",
    auto_49_6bfd048e: "代理商名称",
    auto_490_afc260cf: "活动规则",
    auto_491_6e4b2373: "查看排名",
    auto_492_9435e1c2: "充值区域时长",
    auto_493_c261b541: "充值通用时长",
    auto_494_f48698f1: "撤回申请",
    auto_495_019f0951: "督学状态",
    auto_496_a098bf4b: "督学状态",
    auto_497_af42befc: "数据说明：数据最多存在 1 小时更新延迟，如需了解数据定义，请前往帮助中心",
    auto_499_ce0718ea: "详情",
    auto_5_058edb1d: "请选择非保修原因",
    auto_5_2642db25: "维修金额",
    auto_5_971e3864: "退订生效",
    auto_5_ccf0b2ca: "驳回",
    auto_5_f178aefd: "发放时间",
    auto_50_2ebed531: "返回",
    auto_50_a903f791: "权益名称",
    auto_500_a828735f: "发放时间为必填项，只有选择了发放时间其他的功能才可用，请选择当天日期一个月范围的发放时间",
    auto_501_48092518: "导出",
    auto_502_1e1de5f1: "修改区域",
    auto_503_51e1995f: "冻结后该账户内的订阅时长将无法使用",
    auto_504_4f36b366: "导出",
    auto_505_7ee80f77: "批量下载证书",
    auto_507_3a10ccc6: "操作",
    auto_508_04104a66: "批量分配服务人员",
    auto_509_28f98467: "近180天学员提分个体分析表",
    auto_51_3a73d270: "适用商品",
    auto_51_e10d28d3: "样机订阅卡配件请选择总部发货",
    auto_510_3b232c96: "导出数据",
    auto_511_48a81cbb: "数据说明数据更新频率是每日早上9点更新如需了解数据定义请前往",
    auto_512_8a1c00e3: "督学状态",
    auto_52_1a757eb0: "到期时间",
    auto_52_3e45d83a: "是否变更发货方式为总部发货",
    auto_53_26611724: "该限量机型请选择总部发货",
    auto_53_9b30d563: "权益编码",
    auto_534_729c0a98: "维修金额",
    auto_54_18949a2d: "是否变更发货方式为总部发货",
    auto_54_acf748ec: "门店收货",
    auto_55_49aa702e: "主仓",
    auto_55_c47ac8b0: "学习机智学笔等正价商品请选择区域代理发货",
    auto_558_de3ba6e7: "请选择建议处理方式",
    auto_56_585eb833: "门店收货",
    auto_56_846572c6: "是否变更发货方式为区域代理发货",
    auto_57_52a50233: "确认删除吗",
    auto_57_d944fc10: "请输入详细收货地址例",
    auto_5719_861a1057: "非保修原因:",
    auto_58_3f4e6ee4: "采购单号",
    auto_58_e09984a9: "请选择代理商",
    auto_59_33616ce3: "商品名称",
    auto_59_65f26a9f: "采购单位",
    auto_6_5b16954e: "退订",
    auto_6_7a1f1b69: "请选择非保修原因",
    auto_60_9be5101c: "单价",
    auto_60_9ee15081: "采购单位",
    auto_6003001_02a744ab: "小学",
    auto_6003002_877902ff: "初中",
    auto_6003003_364f8301: "高中",
    auto_6004001_e10db50f: "一年级",
    auto_6004002_0865167a: "二年级",
    auto_6004003_b91584c0: "三年级",
    auto_6004004_5b8f673d: "四年级",
    auto_6004005_54bfd328: "五年级",
    auto_6004006_6df46f26: "六年级",
    auto_6004007_0cb97568: "七年级",
    auto_6004008_8cb729ce: "八年级",
    auto_6004009_67a799aa: "九年级",
    auto_6004010_a35dd9bd: "高一",
    auto_6004011_dac05942: "高二",
    auto_6004012_ca4537e1: "高三",
    auto_6004013_061a6c58: "高四",
    auto_6004020_9fb52f98: "通用",
    auto_6004024_56050475: "中班",
    auto_6004025_a2790b71: "大班",
    auto_61_19561ec4: "数量",
    auto_61_6a47425d: "创建人",
    auto_62_183c5153: "金额",
    auto_62_ea1fd711: "备注",
    auto_63_01613afe: "请输入备注200字以内",
    auto_63_33c01edb: "支付流水号",
    auto_64_3b8387c1: "自定义优惠金额",
    auto_64_9f188f91: "支付方式",
    auto_65_684b34d9: "请输入自定义优惠金额",
    auto_65_e6f5f651: "支付时间",
    auto_66_64fdfb77: "选择添加商品",
    auto_66_fdba32b0: "支付金额",
    auto_67_a43a4a56: "操作人",
    auto_67_e4534610: "商品详情",
    auto_68_399f575c: "发货日期",
    auto_68_ebd45720: "删除",
    auto_69_29f94f29: "快递公司",
    auto_69_fd2821fc: "支付详情",
    auto_7_04ce20b4: "建议处理方式:",
    auto_7_06d7f018:
      "*如果您对维修报价结果有异议，请及时联系客服人员；选择拒修后设备会由厂家寄回",
    auto_7_24eae4ed: "本月已使用额度未超限，无需申请，可直接转入。",
    auto_7_48789045: "请输入SN码",
    auto_7_4bc804a5: "订阅",
    auto_70_736b7933: "预收运费详情",
    auto_70_9406d319: "快递单号",
    auto_71_06c824a3: "物流详情",
    auto_71_1ce95229: "物流状态",
    auto_72_1f5e0a58: "发货数量",
    auto_73_5a28bf46: "收费项目",
    auto_73_70dbabd2: "内容",
    auto_73_f7ef2a1e: "采购金额",
    auto_735_65180f3b: "维修类别",
    auto_74_416952d0: "保存",
    auto_74_69d68a8d: "单价",
    auto_75_bee9082e: "保存并支付",
    auto_75_fafdc271: "数量",
    auto_76_3fc37ef1: "样机订阅卡配件请选择总部发货",
    auto_76_a732542a: "请选择故障分类",
    auto_76_ba853d4f: "金额",
    auto_77_13dfff6e: "是否变更发货方式为总部发货",
    auto_77_326b6100: "优惠金额",
    auto_77_df26ef91: "维修金额合计",
    auto_78_cd7bfcc4: "学习机智学笔等正价商品请选择区域代理发货",
    auto_78_f412d8c2: "门店收货",
    auto_79_c325b4aa: "是否变更发货方式为区域代理发货",
    auto_79_dc062f24: "暂无申报信息",
    auto_8_0518f833: "退订生效",
    auto_8_1fd88c87: "请输入支付说明，400字以内",
    auto_8_2f854118: "您的跨主体设备学员已超出总部允许的最高上限，不可转入。",
    auto_80_9a7d8dda: "待审核",
    auto_80_a0a4046f: "提示",
    auto_81_b96fa279: "确认删除吗",
    auto_81_ead4d6ba: "驳回",
    auto_82_584d7703: "提示",
    auto_82_e97486ea: "通过",
    auto_83_04f546f7: "采购单号",
    auto_83_7c03422b: "附件",
    auto_83_8f5338a9: "协议图片",
    auto_84_724cbd8c: "采购单位",
    auto_84_f3a42535: "开始日期",
    auto_85_6ca0f371: "结束日期",
    auto_85_7fa04e5d: "采购单位",
    auto_86_195870b1: "创建人",
    auto_86_1dc00c5a: "预览",
    auto_87_37398fc9: "采购类型",
    auto_87_8f7f1a88: "申报类型",
    auto_88_0f7b6792: "申报有效期",
    auto_88_b04a7574: "请选择采购类型",
    auto_885_71a4f1a4: "请输入维修说明，400字以内",
    auto_89_56d260b6: "发货区域代理",
    auto_89_6a3150fb: "申报时间",
    auto_9_32922692: "确认",
    auto_9_5429858c:"请上传证明使用学习机的孩子为同一家庭的资料。支持jpg/png的格式，大小不超过20MB",
    auto_9_b8e50bf2: "上传图片/视频大小不能超过 9个!",
    auto_9_d59fe97e: "当前状态无需提交申请或不可提交",
    auto_90_124fbfdc: "申报人",
    auto_90_dfdce47a: "收货人",
    auto_91_2aac4e29: "收货人电话",
    auto_91_7e8833e7: "申报状态",
    auto_916_2233ebaf: "上传图片",
    auto_92_51c9c127: "操作",
    auto_92_fb3a2700: "省市区",
    auto_93_2806a664: "申报详情",
    auto_93_8fbb42a4: "发货方式",
    auto_93438_a86b9958: "实际故障类型:",
    auto_94_6703c8bb: "申报",
    auto_94_6e065e4b: "请选择发货方式",
    auto_94756_d52a8e4d: "维修类别",
    auto_95_4ebaf41d: "待审核",
    auto_95_829a762a: "发货区域代理",
    auto_95_c8654dd5: "序号",
    auto_96_891981ef: "申报成功",
    auto_96_a8f51346: "代理商收货仓",
    auto_97_4b83a8c3: "审核驳回",
    auto_97_9b94a9cf: "代理商收货仓",
    auto_98_9cae1144: "请选择代理商收货仓",
    auto_98_9fc5b955: "再次提交",
    auto_99_7e4f7bcf: "收货地址",
    auto_99_f3974dc0: "假日全日制",
    avgUpScore: "近180天平均提分数",
    back: "邮寄后请在",
    balance: "区域时长（赠送或续费）余额",
    batchAllocatedCustomerAccountUser: "学习中心账号",
    batchAllocatedCustomerServerPeople: "服务人员",
    batchAllocatedCustomerStageGrade: "阶段年级",
    batchAllocatedCustomerStudentName: "姓名",
    batchAllocatedCustomerTitle: "批量分配服务人员",
    batchAssignServicePerson: "批量分配服务人员",
    batchAssignServicePerson508: "批量分配服务人员",
    bayear: "八年级",
    bgImageLoading: "背景图正在加载，请稍候",
    bindConfirmTip1: "1、学员{name}({account})已绑定了其他学习机账户。",
    bindConfirmTip2: "2、确定要将学员{name}({account})换绑到当前学习机账户？",
    bindConfirmTip3: "3、换绑后，该学员原已订阅的学科({subjects})将退订，同时已扣除的订阅时长将不会返还。",
    bindFailed: "绑定失败",
    bindStudentAccount: "绑定学员账号",
    bindSuccess: "绑定成功",
    birthDate: "出生日期：",
    boundAccountCount: "已绑定账号数",
    byAnalyst: "区分分析师",
    byGrade: "区分年级",
    callDuration: "通话时长",
    callEndTime: "通话结束时间",
    callStaff: "通话员工",
    callStaffAccount: "通话员工帐号",
    callStaffName: "通话员工姓名",
    callStartTime: "通话开始时间",
    callTime: "通话时间",
    campus: "校区",
    campusName: "校区名称",
    cancel: "取消",
    cancelFailed: "取消失败",
    cancelOrderConfirmText: "请确认是否取消订单，一旦取消，已支付款项会退回对应的代理商账户和调整对应期货订单额度！",
    cancelShutdown: "取消关闭",
    cancelSubscribe: "取消退订",
    cancelSuccess: "取消成功",
    cancelUnsubscribe15: "取消退订",
    cannotUnbindNotExceedLimit: "账号绑定正式账号数未超上限，不可解绑。",
    caozuo: "操作人",
    certAreaMismatchTip: "新认证区域与常用地不一致，<br/>修改后本月将无法继续使用赠送订阅时长。确定修改吗？",
    certAreaNotExist: "学习机账户认证区域不存在，请先完善认证区域",
    changeStudentPassword: "修改学生密码",
    changeSupervisorStatus: "变更督学状态",
    currentSupervisorStatusLabel: '当前督学状态：',
    analystLabel: '分析师：',
    noAnalyst: '无',
    removeAnalystTip: '(如需解除学员分析师，请在上方“变更督学状态”操作中将督学状态设置为“不督学”）',
    changeType: "变更类型",
    changeTypeActivate: "激活",
    changeTypeChangeArea: "变更区域",
    changeTypeExtraGift: "加量不加价赠送",
    changeTypeGift: "赠送",
    changeTypeGiftRenew: "赠送续订",
    changeTypeOnePersonOneReturn: "一人一号返还",
    changeTypeOpenSubscribe: "开通订阅",
    changeTypeRenew: "续订",
    changeTypeSubscribe: "订阅",
    changeTypeWrongReturn: "误订阅返还",
    checkFaceChangeLearningMachine_1: "请求参数不能为空",
    checkFaceChangeLearningMachine_2: "变更过于频繁，无法更换账户手机号",
    checkFaceChangeLearningMachine_3: "仅已完成实名认证的账号所在的学习机可更换账户手机号，请先完成人脸实名认证后再试",
    checkFaceChangeLearningMachine_networkError: "网络错误，请稍后重试",
    chemistry: "化学",
    chinese: "语文",
    chuangjian: "创建人",
    ci: "下次跟进",
    cityLevel: "城市档数",
    cityLevelLabel: "城市档数:",
    clearanceCycleDays: "通关周期（天）",
    clearanceTime: "通关时间",
    clearFilter: "清除筛选",
    clickUpload: "点击上传",
    closeAutoRenewal: "关闭自动续费",
    closeAutoRenewalConfirm: "关闭自动续费",
    closeAutoRenewalTip: "是否关闭自动续费？关闭后服务到期将不会自动续费",
    closeFailed: "关闭失败",
    closeSuccess: "关闭成功",
    coinMall: "金币商城",
    collectCount: "采集次数",
    commonArea: "常用地",
    commonAreaLabel: "常用地:",
    complete: "已完成",
    completePaymentWithin: "】页面查看维修报价详情，并选择是否付款。如有异议，请及时联系客服人员。",
    confirm: "确认",
    confirm2: "确定",
    confirmFreezeAccount: "确认要将账户{account}{action}吗？",
    confirmModify: "确认修改",
    confirmUnbind14: "确定解绑吗",
    confirmUnbind15: "是否需要解除学员与服务人员的关系？确认后，解除两者的服务关系。",
    confirmUnsubscribe: "确定退订吗？",
    confirmUnsubscribe12: "确定退订吗？",
    confirmWithdrawApply: "确定要撤回此次申请吗？",
    confirmWithdrawApply13: "确定要撤回此次申请吗？",
    contact: "联系人",
    contact1: "联系人1:",
    contact2: "联系人2:",
    contact3: "联系人3:",
    contactInfo: "联系方式",
    correctNewSNCode406: "更正新SN码",
    correctNewSNCode415: "更正新SN码",
    correctRate: "正答率",
    correctRateOrScoreRate: "正答率（或得分率）",
    courseName: "课程名称",
    courseType: "课程类型",
    courseTypeFormal: "正式课",
    courseTypeFormalRetake: "正式课重学",
    courseTypeFoundation: "打地基",
    courseTypeFoundationDowngrade: "打地基降级",
    courseTypeFoundationRetake: "打地基重学",
    courseTypeFoundationUpgrade: "打地基升级",
    courseTypeRetake: "重学",
    courseTypeSyncStudy: "同步学",
    createTime: "创建时间",
    crossEntityApplyStatus: "申请状态",
    crossEntityApplyStatusApproved: "审核通过",
    crossEntityApplyStatusPending: "待审核",
    crossEntityApplyStatusRejected: "审核驳回",
    crossEntityApplySuccess: "跨主体督学申请提交成功",
    crossEntityAuditor: "审核人",
    crossEntityAuditTime: "审核时间",
    crossEntityDealerId: "设备经销商ID",
    crossEntityDealerName: "设备经销商名称",
    crossEntityDevice: "您的跨主体设备学员已",
    crossEntityDialogAuditOptionApprove: "审核通过",
    crossEntityDialogAuditOptionReject: "审核拒绝",
    crossEntityDialogAuditRemarkPlaceholder: "请输入审核意见",
    crossEntityDialogAuditResult: "审核结果",
    crossEntityDialogAuditStatus: "审核状态",
    crossEntityDialogBtnCancel: "取消",
    crossEntityDialogBtnClose: "关闭",
    crossEntityDialogBtnSubmitApply: "提交申请",
    crossEntityDialogBtnSubmitAudit: "提交审核",
    crossEntityDialogClickUploadImage: "点击上传图片",
    crossEntityDialogGuideLine1: "学员购买的设备并非您同主体经销商名下设备时，学员为跨主体督学学员。",
    crossEntityDialogGuideLine2: "如您需要转入此类学员进行服务，需要提交审核后，待省代同意后方能转入。",
    crossEntityDialogProofDocuments: "证明文件",
    crossEntityDialogProofImageAlt: "证明文件",
    crossEntityDialogRuleAuditRemark: "请输入审核意见",
    crossEntityDialogRuleAuditResult: "请选择审核结果",
    crossEntityDialogRuleDescriptionLength: "情况说明长度为5-200字",
    crossEntityDialogRuleDescriptionRequired: "请输入情况说明",
    crossEntityDialogRuleEvidence: "请上传证明文件",
    crossEntityDialogRuleStudentAccount: "请输入学员账号",
    crossEntityDialogSelectAuditResult: "请选择审核结果",
    crossEntityDialogSituationDescription: "情况说明",
    crossEntityDialogSituationPlaceholder: "请输入情况说明（5-200字）",
    crossEntityDialogStudentAccountPlaceholder: "请输入学员账号",
    crossEntityDialogTitleAudit: "审核跨主体督学申请",
    crossEntityDialogTitleCreate: "新增跨主体督学申请",
    crossEntityDialogTitleFallback: "跨主体督学申请",
    crossEntityDialogTitleView: "跨主体督学申请详情",
    crossEntityDialogTransferServiceCenterId: "转入服务中心ID",
    crossEntityDialogTransferServiceCenterName: "转入服务中心名称",
    crossEntityDialogUploadProofHint: "请上传督学服务购买凭证和与家长的沟通记录",
    crossEntityStudentAccount: "学员账号",
    crossEntityStudentName: "学员姓名",
    crossEntityStudentNameAccount: "学员姓名账号",
    crossEntitySubmitter: "申请提交人",
    crossEntitySubmitTime: "申请提交时间",
    crossEntitySupervisionQuotaArea: "所属区域",
    crossEntitySupervisionQuotaCurrentUsedLimit: "当前经销商已使用额度",
    crossEntitySupervisionQuotaDealer: "经销商：",
    crossEntitySupervisionQuotaDealerId: "经销商ID",
    crossEntitySupervisionQuotaDealerName: "经销商名称",
    crossEntitySupervisionQuotaDealerPlaceholder: "请输入经销商ID",
    crossEntitySupervisionQuotaExemptLimit: "服务同主体免审核额度",
    crossEntitySupervisionQuotaPeriod: "统计周期：",
    crossEntitySupervisionQuotaStudentCount: "服务同主体加入的督学学员数",
    crossEntitySupervisionQuotaUpperLimit: "服务同主体上限额度",
    crossEntitySupervisionQuotaUsedLimit: "服务同主体已使用额度",
    currentCertArea: "当前认证区域",
    currentCertAreaLabel: "当前认证区域:",
    currentCommonAreaLabel: "当前常用地:",
    currentServiceCenter: "现服务中心：",
    currentServiceCenterId: "现服务中心ID：",
    currentServiceCenterName: "现服务中心名称：",
    currentStudyEndDate: "当前学习截止日期",
    currentStudyEndDate31: "当前学习截止日期",
    customDiscountExceedTotal: "自定义优惠金额不能大于原价合计",
    customer: "搜索客户",
    customerName: "客户姓名",
    customerName255: "客户姓名",
    customerSubmitted: "客户提交的",
    dailyKnowledgePointSelfStudyCount: "当天知识点自学数",
    danhao: "返修单号",
    dataDescription: "数据说明",
    dataDescriptionByMonth: "数据说明:数据每月1号，如需了解数据定义，请前往帮助中心",
    dataDescriptionDayDelay: "数据说明：数据有 1 天延迟，每日凌晨更新，如需了解数据定义，请前往帮助中心",
    dataDescriptionTip: "数据最多存在 1 小时更新延迟，如需了解数据定义，请前往帮助中心",
    date: "日期",
    dateLabel: "日期：",
    day: "统计日",
    dayhour: "日志统计开始时间",
    ddjDurationInPeriod: "周期内打地基时长",
    ddjEffectAbnormal: "打地基自学效果是否异常：",
    ddjEfficiencyAbnormal: "打地基自学效率是否异常：",
    ddjValidStudyTime: "近180天打地基有效时长",
    dealer: "经销商ID",
    dealerId: "经销商 ID",
    dealerId35: "经销商ID",
    dealerIdLabel: "经销商ID:",
    dealerName: "经销商名称",
    dealerName36: "经销商名称",
    dealerNameLabel: "经销商名称:",
    deductDurationLabel: "本次扣除订阅时长:",
    deleteSuccess: "删除成功！",
    deliveryAddressLabel: "收货地址：",
    detail: "详情",
    detail403: "详情",
    detailedDescription413: "详细说明",
    details: "详情",
    detection397: "检测",
    device: "设备SN码",
    deviceDiagnosedByVendor: "设备经过厂商诊断",
    deviceDiagnosedByVendorNeedRepair: "设备经过厂商诊断需要进行保外维修",
    deviceRepairApplications: "个设备维修申请",
    deviceSNCode: "设备SN码",
    deviceSNCodeLabel: "设备SN码:",
    dialTime: "拨打时间",
    dianhua: "收件人电话",
    dili: "地理",
    dingshiqu: "订阅时长区域",
    disableSuccess: "禁用成功",
    discountAmount: "优惠金额",
    dishu: "打地基次数",
    displaySwitchDesc: "展示开关（开启后会展示在自提商店）",
    disputeResult405: "争议结果",
    distributionTime: "发放时间",
    download: "下载",
    downloadElectronicCert: "下载电子证书",
    downloadEnrollmentPoster: "下载报名海报",
    downloadFailed: "下载失败",
    downloadSuccess: "下载成功",
    durationDetailHours: "时长明细(小时)",
    duxueStatusExpiring: "督学即将到期",
    editCustomerArchive: "编辑客户档案",
    editFailed: "编辑失败",
    editSuccess: "编辑成功",
    effectiveDurationHours: "有效时长(小时)",
    enableSuccess: "启用成功",
    english: "英语",
    englishName: "英文名",
    enrollmentName: "报名名称",
    enrollmentPosterFilename: "{userName}的报名海报-{createTime}.png",
    enrollParent: "报名家长",
    enrollTime: "报名时间",
    enterPhone: "请输入手机号码",
    enterProductName: "请输入商品名称",
    enterSchool: "请输入学校",
    er: "支付二维码有效期是",
    errorCategory: "异常情况分类",
    errorCount: "异常次数",
    errorRate: "异常占比",
    eryear: "二年级",
    evaluate407: "评价",
    evaluateServiceHere197: "在此处评价本次服务",
    examScoreUpRate: "近180天考试提分率",
    exchangeLearningMachine: "互换关联学习机",
    exchangeMachineSN: "需互换学习机SN码",
    exchangePrice: "兑换价格",
    exchangeSuccess: "互换成功！",
    expectedGiftHours: "应赠送时长",
    expirationTime: "过期时间",
    export: "导出",
    exportFailRetry: "导出失败，请稍后重试",
    exportReport: "导出报表",
    faceRiskBaselinePhotoLabel: "人脸基准照片",
    faceRiskCollectionMethodLabel: "采集方式",
    faceRiskCompareImageLabel: "图片",
    faceRiskLivenessMethodLabel: "活体检测方式",
    faceRiskRecognitionSimilarityLabel: "识别相似度",
    factoryExpressNoLabel: "返厂快递",
    fastTrackBindNoAuditDesc: "此通道使用后，此账号绑定免审核。",
    fastTrackNoAudit: "免审核快速通道",
    faultType411: "故障类型",
    faultType412: "故障类型",
    feedbackThanks: "您的反馈是我们努力的动力！",
    female: "女",
    fen: "活体得分",
    fenlei: "实际故障分类",
    fieldDescription: "字段说明",
    fileUploadingWait: "文件正在上传中，请稍候再提交",
    fill: "填写",
    fillAddressStep: "填写寄送地址",
    fillEnglishName: "填写学员英文姓名",
    fillExpressInfo: "】页面填写您的快递信息、回寄信息。",
    fillQuotation398: "填写报价单",
    finalAbilityValue: "最终能力值",
    finalAvgAbility: "最终平均能力值",
    fiveStarCount: "5星人科数",
    followContent: "跟进内容:",
    followContentPlaceholder: "请输入跟进内容",
    followStatusNoFollowNeeded: "无需跟进",
    followStatusNoLimit: "不限",
    followStatusPendingFollow: "待跟进",
    foundationCourseStudyDuration: "打基础课程学习时长",
    foundationDuration: "打基础时长",
    foundationEffectiveDuration: "打基础有效时长",
    foundationErrorCorrectionDuration: "打基础错题订正时长",
    foundationStudyDuration: "打地基学习时长",
    fourStarCount: "4星人科数",
    freeze: "冻结",
    freezeSubscriptionTip: "冻结后，该账户内的订阅时长将无法使用。",
    freezeSuccess: "账户冻结成功",
    frozen: "冻结",
    fulltime: "全日制",
    fullTime: "全日制：",
    fulltimeInfoIncompleteTip: "请先完善学生就读学校和年级信息后才可申报",
    fulltimeType1Tip: "（≥5小时）",
    fulltimeType2Tip: "（≥25小时）",
    gender: "性别:",
    generalAvailableDuration24: "通用可用学习时长",
    generatingText: "生成中...",
    gengqu: "变更区域",
    giftedHours: "已赠送时长",
    giftFailed: "赠送失败",
    giftReason: "赠送原因",
    giftSubscriptionBalance: "赠送订阅时长余额",
    giftSubscriptionCardUsage: "赠送订阅卡使用",
    giftSubscriptionDuration: "赠送订阅时长",
    giftSubscriptionDurationLabel: "赠送订阅时长",
    giftSubscriptionMonths: "赠送订阅时长月数",
    giftSubscriptionType: "赠送订阅时长种类",
    giftSuccess: "赠送成功",
    goDeclare: "去申报",
    goNow: "立即前往",
    gotIt: "我知道了",
    grade: "年级",
    grantReason: "发放原因",
    grantUser: "发放人",
    guinnessElectronicStatusHeader: "电子证书状态",
    guinnessElectronicStatusLabel: "电子证书状态：",
    guinnessEnglishNameLabel: "英文姓名",
    guinnessPaperStatusHeader: "纸质证书状态",
    guinnessPaperStatusLabel: "纸质证书状态：",
    guinnessStatusApplied: "已申请",
    guinnessStatusAppliedMaking: "已申请，制作中",
    guinnessStatusCompleted: "已完成",
    guinnessStatusNotApplied: "未申请",
    guinnessStatusPaying: "付款中",
    guinnessStudentAccountHeader: "学员账号",
    guinnessStudentNameText: "学生姓名",
    hao: "一人一号返还",
    hasBeenApproved: "已经审核通过。",
    healthDegree: "健康度",
    healthPersonCount: "健康人科数",
    healthRate: "健康占比",
    highActiveDuration: "高活时长",
    highActiveEffectiveDuration: "高活有效时长",
    highActiveEffectiveRatio: "高活有效时长占比",
    highActiveRate: "高活占比",
    homeAddress: "家庭地址：",
    homeAddressLabel: "家庭住址:",
    homeAddressPlaceholder: "请输入家庭住址",
    hour: "订阅时长明细",
    hourhour: "念念有词时使用时长报表",
    hoursTipAreaMatch: "常用地与认证区域一致，建议充值区域时长",
    hoursTipAreaMismatch: "常用地与认证不一致，建议充值通用时长",
    hoursTipUniversal: "当前可使用通用时长订阅，请根据实际需求选择充值时长类型",
    houryici: "这时候直接用上一次的参数",
    houryoubackyou: "选择是否付款。如有异议，请及时联系客服人员。感谢您的配合，售后人员将加速为您处理！",
    hua: "视频通话服务",
    id: "编号",
    iKnow: "我知道了",
    imageAddFailed: "图片添加失败",
    imageFormatJpgPngGifBmp: "只能上传JPG 、JPEG 、GIF、 PNG、 BMP格式的图片~",
    imageLoadFailCheckNetwork: "图片加载失败，请检查网络连接",
    imageMax9Count: "上传的图片不能超过9张~",
    imageNoDuplicate: "禁止上传重复图片~",
    imageSizeExceed5M: "超过5M限制 不允许上传~",
    imageSizeExceed8M: "上传图片大小不能超过 8MB！",
    info: "人脸2最相似人脸信息",
    information: "信息",
    initialDiagnosis396: "初诊",
    invalidReason: "失效原因",
    invalidReasonPlaceholder: "100字以内",
    inviteStudentTransfer: "邀请学员转入",
    inviteTransfer: "邀请转入",
    jianli: "建议处理方式",
    jie: "识别结果",
    jiuyear: "九年级",
    kaiding: "开通订阅",
    kanshi: "视频观看时长（非精确）",
    kexue: "科学",
    knowIt: "知道了",
    knowledgePointCode: "知识点code",
    knowledgePointName: "知识点名称",
    knowledgePointNote: "知识点笔记",
    lastExamDate: "最近一次考试日期",
    learnable: "可学",
    learnable286: "可学",
    learningArea: "学习区域",
    learningArea23: "学习区域",
    learningAreaLabel: "学习区域:",
    learningCenterAccount: "学习中心账号",
    learningMachineAccount: "学习机管理账户",
    learningMachineAccount266: "学习机管理账户",
    learningMachineSNCode410: "学习机SN码",
    li: "物理",
    lijie: "维修处理结果",
    linkedStudents: "已关联学员",
    liuyear: "六年级",
    loadFailed: "加载失败",
    loadingText: "加载中...",
    long: "长期",
    ma: "SN码：",
    machine: "学习机账户",
    machineAccount: "学习机账户:",
    machineAccount22: "学习机账户",
    machineAccount34: "学习机账户",
    machineAccount47: "学习机账户",
    machineAccountCode: "学习机账户编号:",
    machineAccountLabel: "学习机账户：",
    machineAccountPhoneLabel: "学习机账户手机号:",
    machineRenewal: "学习机续订",
    machineSNCode: "学习机SN码",
    machineSNCodeLabel: "学习机SN码:",
    machineSubscribeStatus: "学习机订阅状态",
    machineSubscribeStatus29: "学习机订阅状态",
    maintenanceActualFaultType: "实际故障分类",
    maintenanceActualMethod: "实际处理方式",
    maintenanceApplyNo: "返修单号",
    maintenanceApplyNoLabel: "维修单号:",
    maintenanceAuditor: "审核人",
    maintenanceAuditRemark: "审核备注",
    maintenanceAuditTime: "审核时间",
    maintenanceConfirmTime: "确认时间",
    maintenanceCreateTime: "创建时间",
    maintenanceCreator: "创建人",
    maintenanceDeviceSnOrPurchaseNo: "设备SN码/采购单号",
    maintenanceDeviceSnOrPurchaseNoLabel: "设备SN码/采购单号:",
    maintenancePaymentButtonPay: "支付",
    maintenancePaymentPayAmount: '支付{symbol}{amount}{unitSuffix}',
    maintenanceAddRepairDetailDialogTitle: "添加维修明细",
    maintenanceQuotationCustomDiscountTip: "自定义优惠金额:",
    maintenanceQuotationDescriptionLabel: "报价说明:",
    maintenanceEstimateFaultType: "预估故障分类",
    /** 维修申请 RepairApply 详细说明（避免 auto_334 / auto_157 在美版未命中） */
    maintenanceRepairApplyDetailLabel: "详细说明：",
    maintenanceRepairApplyDetailPlaceholder: "请输入详细说明400字以内",
    maintenanceExpressNo: "快递单号",
    /** 维修流转记录 content.resultType：1 支付 2 驳回 3 拒修退回 */
    maintenanceFlowResultType1: "支付",
    maintenanceFlowResultType2: "驳回",
    maintenanceFlowResultType3: "拒修退回",
    maintenanceFirmUser: "维修厂商",
    repairFirmUser_17017: "中教博尔",
    repairFirmUser_17037: "上海米雪",
    repairFirmUser_122895: "中教博尔(维修)",
    repairFirmUser_123169: "中教博尔(发货)",
    repairFirmUser_123533: "TCL（发货）",
    repairFirmUser_127795: "TCL（维修）",
    repairFirmUser_128444: "淘宝C店发货",
    repairFirmUser_128112: "深圳服务中心(维修)",
    repairFirmUser_127796: "BOE（维修）",
    maintenanceFirstDiagnosisMethod: "初诊处理方式",
    maintenancePdfPayTitle: "扫码支付",
    maintenancePleaseEnterApplyNo: "请输入维修单号",
    maintenancePleaseEnterNewSNCode: "请输入新 SN码",
    newSNCodelabel: "新SN码",
    maintenancePleaseEnterPurchaseNo: "请输入采购单号",
    maintenancePleaseSelectActualFaultType: "请选择实际故障分类",
    maintenancePleaseSelectEstimateFaultType: "请选择预估故障分类",
    maintenancePleaseSelectFirmUser: "请选择维修厂商",
    maintenancePleaseSelectProductType: "请选择商品类型",
    maintenancePleaseSelectQuotationPayType: "请选择是否报价付款",
    maintenanceProcessResult: "维修处理结果",
    maintenanceProcessTime: "维修时间",
    maintenanceProductModel: "产品型号",
    maintenanceProductType: "商品类型",
    maintenancePurchaseNoLabel: "采购单号:",
    maintenanceQuotationPayType: "是否报价付款",
    maintenanceQuotationTime: "报价时间",
    maintenanceQuotedPaid: "已报价已付款",
    maintenanceQuotedUnpaid: "已报价未付款",
    maintenanceReceiverPhone: "收件人电话",
    maintenanceRenewEffectiveTime: "换新有效时间",
    maintenanceSearchActualMethodLabel: "实际处理",
    maintenanceSearchFirstDiagnosisMethodLabel: "初诊处理",
    maintenanceSearchProposeMethodLabel: "建议处理",
    maintenanceSuggestMethod: "建议处理方式",
    maintenanceWarrantyValidTime: "保修有效时间",
    male: "男",
    math: "数学",
    math2: "数学",
    math281: "数学",
    maxBindLimit: "账号绑定上限",
    min: "实际不需要分页",
    minhour: "分页的时候",
    minmin: "天学员提分个体分析表",
    minyear: "区分年级表格列",
    missingAccountInfo: "缺少必要的账号信息，无法操作",
    mobile: "手机号",
    mobileRequired: "手机号不能为空",
    modify393: "修改",
    modifyArea: "修改区域",
    modifyAreaFailed: "修改区域失败",
    modifyAreaSuccess: "修改区域成功",
    modifySuccess: "修改成功",
    month: "订阅时长月数",
    month24: "个月",
    monthAvgPrice: "月均价",
    monthlyRemainQuota: "本月剩余可使用额度",
    monthsUnit: "个月",
    monthUnit: "月",
    more: "更多",
    name: "名称",
    nameEditOnce: "姓名仅限修改一次",
    nationwide: "全国",
    needReplacementSendBack: "需要换新寄回",
    newApplication: "新增申请",
    newMachineAccount: "新学习机账户",
    newMachineAccountArea: "新学习机账户学习区域",
    newPasswordLabel: "密码:",
    newPasswordPlaceholder: "请输入6-32位密码,仅支持数字或英文",
    newPhone: "新手机号",
    newPhoneLabel: "新手机号:",
    newStudentFacePhoto: "新学员人脸实名照片",
    newStudentFacePhoto43: "新学员人脸实名照片",
    newStudentFacePhotoLabel: "新学员人脸实名照片:",
    newStudentName: "新学员姓名",
    newStudentName42: "新学员姓名",
    newStudentNameLabel: "新学员姓名:",
    nextCommunicateTime: "下次沟通时间",
    nextFollow: "下次跟进:",
    nextFollowPlaceholder: "选择下次跟进时间",
    nextStep: "下一步",
    nnycDuration: "念念有词时长",
    no: "否",
    noData: "暂无数据",
    none: "暂无",
    noNeedApply: "当前状态无需提交申请",
    normal: "正常",
    not: "未开通",
    notHeld: "未持有",
    notHeld282: "未持有",
    notLearnable: "不可学",
    notLearnable287: "不可学",
    notRecommended: "不推荐",
    notRecommended285: "不推荐",
    notSubscribed: "未订阅",
    notUse: "不使用",
    num: "人脸数量",
    objectiveQuestionCount: "客观题数",
    oldPassword: "原密码",
    oneStarCount: "1星人科数",
    onlyLastHalfYearTip: "* 仅展示近半年数据，更多学习数据请前往分析师系统查看",
    onlyLastYearTip: "* 仅展示近一年数据，更多学习数据请前往分析师系统查看",
    onlyUploadImage: "只能上传图片文件！",
    openAutoRenewal: "开通自动续费",
    openAutoRenewalConfirm: "开启自动续费服务",
    openAutoRenewalTip: "是否需要开启自动续费？开启后服务到期将会自动续费",
    openFailed: "开通失败",
    openService: "开通服务",
    openSuccess: "开通成功",
    openVideoCallService: "开通视频通话服务",
    operateChannel: "操作渠道",
    operateDate: "操作日期",
    operateTime: "操作时间",
    operateType: "操作类型",
    operation: "操作",
    operation16: "操作",
    operation32: "操作",
    operation414: "操作",
    operationFail: "操作失败",
    operationSuccess: "操作成功",
    operator: "操作人",
    systemAdministrator: "系统管理员",
    originalPhone: "原手机号",
    originalPhoneLabel: "原手机号:",
    originalPriceTotalLabel: "原价合计：",
    originStudyTimeSec: "原学习时长(秒)",
    otherSubject: "其他",
    outOfWarrantyRepairRequiresFee: "由于保外维修需要收取维修费用，请您在",
    overallCorrectRate: "总体正答率",
    pass: "短期临时通行证",
    passHeld: "通关证持有中",
    passHeld283: "通关证持有中",
    passportRecordAdaptiveAccountText: "智适应账号",
    passportRecordExport: "通行证发放记录导出",
    passportReviewComplete: "复盘完成",
    passportReviewNoNeed: "无需复盘",
    passportReviewPending: "待复盘",
    passportStudyData: "学员通行证学习数据",
    passStatus: "通行证状态",
    passStatus263: "通行证状态",
    password: "密码:",
    pay: "支付",
    payDeductTip: "本次支付将扣除：",
    payFailTip: '未能成功支付{symbol}{money}{unitSuffix}',
    paymentCompleted: "已经完成付款",
    paymentFailed: "付款失败",
    paymentSuccess: "付款成功",
    paymentSuccessExclaim: "支付成功！",
    paySuccessTip: '成功支付{symbol}{money}{unitSuffix}',
    pending: "待复盘",
    pendingApprovalRetry: "有待审核账号，请等待审核后重试",
    phoneColon: "手机号:",
    phoneLabel: "手机号:",
    phoneNumber: "手机号",
    phoneNumber256: "手机号",
    phoneRebind: "手机号换绑",
    phoneRebindTitle: "手机号换绑",
    phoneVerifyCode: "手机验证码:",
    physics: "物理",
    pickupExchangeDesc: "启用自提商店商品兑换功能后，你的学员可以在自提商店进行下单，下单后你需要提供对应实物商品给学员，并且在代理商小程序订单管理中确认兑换，确认兑换后将结算订单的金币给你",
    pickupStore: "自提商店",
    pickupStoreDisplaySetting: "自提商店展示设置",
    pleaseAddProductQty: "请添加商品数量",
    pleaseEnter: "请输入SN码",
    pleaseEnterAccountStatus: "请输入账号状态",
    pleaseEnterAdaptiveAccount: "请输入智适应账号",
    pleaseEnterAddress: "请输入收货地址",
    pleaseEnterAgentWarehouse: "请输入代理商收获仓",
    pleaseEnterAnalystNamePhone: "请输入分析师名称、手机号",
    pleaseEnterAuditRemark: "请输入审核备注",
    pleaseEnterChangeType: "请输入变更类型",
    pleaseEnterCityDistrict: "请输入市区",
    pleaseEnterCrossEntityStudentNameAccount: "请输入学员姓名账号",
    pleaseEnterDetailAddress: "请输入详细收货地址，例如x x x省份xxx市xxx区xxx街道xxx号",
    pleaseEnterDetailDesc: "请输入详情说明",
    pleaseEnterDeviceSN: "请输入设备SN",
    pleaseEnterDeviceSNOrOrderNo: "请输入设备SN/采购单号",
    pleaseEnterEnglishName: "请输入学员英文姓名",
    pleaseEnterFirstDiagnosisResult: "请输入初诊结果",
    pleaseEnterInspectionDesc: "请输入检测说明",
    pleaseEnterMachineAccount: "请输入学习机账户",
    pleaseEnterMachineAccountPhone: "请输入学习机账户手机号",
    pleaseEnterNameAccount: "请输入姓名、账号",
    pleaseEnterNameOrAccount: "请输入姓名、账号",
    pleaseEnterNewMachineSN: "请输入新机SN码",
    pleaseEnterNewPhone: "请输入新手机号",
    pleaseEnterNewSNCode416: "请输入新SN码",
    pleaseEnterPhone: "请输入手机号",
    pleaseEnterProvinceCity: "请输入省市区",
    pleaseEnterPurchaseType: "请输入采购类型",
    pleaseEnterQualityRemark: "请输入质检备注",
    pleaseEnterQuotationDesc: "请输入报价说明",
    quotationDescInputPlaceholder: "请输入报价说明，400字以内",
    pleaseEnterReceiver: "请输入收货人",
    pleaseEnterReceiverAddress: "请输入收件人地址",
    pleaseEnterReceiverPhone: "请输入收件人电话",
    pleaseEnterRechargeActivityDuration: "请输入充值活动时长",
    pleaseEnterRemark: "请输入备注",
    pleaseEnterRepairResult: "请输入维修结果",
    pleaseEnterReturnReceiver: "请输入回寄人",
    pleaseEnterServiceCenterIdName: "请输入服务中心ID,服务中心名称",
    pleaseEnterSNCode: "请输入SN码",
    pleaseEnterStudentAccount: "请输入学生账号",
    pleaseEnterStudentAccountOrName: "请输入学员账号、学员姓名",
    pleaseEnterStudentName: "请输入学员名称",
    pleaseEnterStudentNameOrAccount: "请输入学员姓名/账号",
    pleaseEnterStudentNamePhone: "请输入学员姓名/手机号",
    pleaseEnterStudentNamePhoneAccount: "请输入学员名称、手机号、账号",
    pleaseEnterTrackingNo: "请输入快递单号",
    pleaseEnterUser: "请输入用户",
    pleaseEnterUserAccountOrName: "请输入用户账号或用户姓名",
    pleaseEnterUserPlaceholder: "请输入用户",
    pleaseEnterValidPhone: "请填写有效的手机号",
    pleaseEnterVerifyCode: "请输入验证码",
    pleaseEnterVideoCallStudentNameAccount: "请输入学员姓名、账号",
    pleaseFillApplicationReason: "请填写申请原因",
    pleaseFillCardNo: "请填写订阅卡卡号",
    pleaseFillCardPassword: "请填写订阅卡密码",
    pleaseFillGiftDuration: "请填写赠送订阅时长",
    pleaseFillGiftReason: "请填写赠送原因,最少两个字，最大200字",
    pleaseFillMachineSN: "请填写学习机SN码",
    pleaseFillMonth: "请填写月份",
    pleaseFillNewPhone: "请填写新手机号",
    pleaseFillNewStudentName: "请填写新学员姓名",
    pleaseFillOriginalPhone: "请填写原手机号",
    pleaseFillRemark: "请填写备注",
    pleaseFillStudentAccount: "请填写学员账号",
    pleaseGoToRepairManagement: "【服务中心】—【维修管理】—【",
    pleaseMailDeviceToServiceCenter: "1、请您及时邮寄设备给售后中心，信息如下：",
    pleaseSearchCourseName: "请搜索课程名称",
    pleaseSearchStudyCount: "请搜索第几次自学",
    pleaseSelect: "请选择操作类型",
    pleaseSelectAccountStatus: "请选择账户状态",
    pleaseSelectActualFaultType: "请选择实际故障类型",
    pleaseSelectActualMethod: "请选择实际处理方式",
    pleaseSelectAfterSalesMethod: "请选择售后方式",
    pleaseSelectAgent: "请选择代理商",
    pleaseSelectAssignPerson: "请选择分配人员",
    pleaseSelectAtLeastOneOption: "请至少选择一个选项",
    pleaseSelectAuditResult: "请选择审核结果",
    pleaseSelectCallStaff: "请选择通话员工",
    pleaseSelectChangeType: "请选择变更类型",
    pleaseSelectCourseType: "请选择课程类型",
    pleaseSelectCrossEntityApplyStatus: "请选择申请状态",
    pleaseSelectDateRange: "请选择日期范围",
    pleaseSelectDispatchType: "请选择方式",
    pleaseSelectExpectedTime: "请选择预计完成时间",
    pleaseSelectExpressCompany: "请选择快递公司",
    pleaseSelectFillResult: "请选择填写结果",
    pleaseSelectFirstDiagnosisMethod: "请选择初诊处理方式",
    pleaseSelectFirstDiagnosisResult: "请选择初诊结果",
    pleaseSelectFullTimeDateRange: "请选择全日制起止日期",
    pleaseSelectFullTimeType: "请选择全日制类型",
    pleaseSelectGiftType: "请选择赠送订阅时长种类",
    pleaseSelectGrade: "请选择年级",
    pleaseSelectInspectionResult: "请选择检测结果",
    pleaseSelectMonth: "请选择月份",
    pleaseSelectNonWarrantyReason: "请选择非保修原因",
    pleaseSelectPassportType: "请选择通行证类型",
    pleaseSelectPaymentResult: "请选择支付结果",
    pleaseSelectProductFirst: "请先选择商品",
    pleaseSelectProvinceCity: "请选择省份/市",
    pleaseSelectPurchaseType: "请先选择采购类型",
    pleaseSelectQualityResult: "请选择质检结果",
    pleaseSelectRenewDurationType: "请选择续订时长类型",
    pleaseSelectRenewMonth: "请选择续订月份",
    pleaseSelectRepairResult: "请选择维修结果",
    pleaseSelectRepairVendor: "请选择返修厂商",
    pleaseSelectResult: "请选择结果",
    pleaseSelectReturnResult: "请选择回寄结果",
    pleaseSelectReviewStatus: "请选择复盘状态",
    pleaseSelectServicePerson: "请选择服务人员",
    pleaseSelectShipAreaAgent: "请选择发货区域代理",
    pleaseSelectStatus: "请选择状态",
    pleaseSelectSubject: "请选择科目",
    pleaseSelectSuggestMethod: "请选择建议处理方式",
    pleaseSelectSupervisorMark: "请选择督学标记",
    pleaseSelectSupervisorShop: "请选择门店",
    pleaseTimelyRepairProcess: "请您及时进行维修处理",
    pleaseTimelyReturnProcess: "请您及时进行寄回处理",
    pleaseUploadFullTimeAgreement: "请上传签署的全日制协议",
    pleaseUploadImage: "请上传图片",
    pleaseUploadImageOrVideo: "请上传图片/视频",
    pleaseUploadReturnMedia: "请上传回寄图片/视频",
    posterGeneratedDownload: "海报已生成，开始下载",
    postLearningAccuracy: "学后正确率",
    postStudyAvgAbility: "学后平均能力值",
    precisionTestDuration: "精准测时长",
    preLearningAccuracy: "学前正确率",
    preTestCorrectRate: "先测正答率",
    prevStep: "上一步",
    priceLabel: "价格:",
    processImmediately: "立即处理",
    productImage: "商品图片",
    productName: "商品名称",
    profileCompleted: "已完善",
    profileNotCompleted: "未完善",
    proofMaterial: "证明材料",
    proofMaterial44: "证明材料",
    proofMaterialLabel: "证明材料:",
    proofUploadTip: "请上传证明使用学习机的孩子为同一家庭的资料。支持jpg/png的格式，大小不超过20MB",
        proofUploadTipAtLeast2: "至少需要上传2张图片",
    proofUploadTip9: "请上传证明使用学习机的孩子为同一家庭的资料。支持jpg/png的格式，大小不超过20MB",
    providePickupExchange: "提供自提商店商品兑换功能",
    provinceCityLabel: "省市区：",
    public: "快递公司名称",
    purchase: "采购单号:",
    qi: "过期原因",
    qingtijiao: "申请提交人",
    qita: "其他",
    qiyear: "七年级",
    qu: "所属区域",
    qualityInspection401: "质检",
    qualityInspectionCompleted: "已经完成质检",
    queryFailRetry: "查询失败，请稍后重试",
    queryRenewMonthFailed: "查询续订月份失败",
    questionCount: "答题数",
    quotaNotExceeded: "本月已使用额度未超限",
    realNameAuth: "是否认证实名人脸",
    realNameAuth258: "是否认证实名人脸",
    rebindFailed: "换绑失败",
    rebindSuccess: "换绑成功",
    receiverLabel: "收货人：",
    receiverPhoneLabel: "收货人电话：",
    recentModuleName: "最近自学模块名称",
    recentSubscribeCancelDate30: "最近订阅/取消订阅日期",
    rechargeActivityDuration: "充值活动时长",
    rechargeActivityDurationReminder: "充值活动时长提醒",
    rechargeAreaDuration: "充值区域时长",
    rechargeAreaDurationTitle: "充值区域时长",
    rechargeAtServiceCenter: "如学员为您服务中心下学员，请在服务中心账户管理页面进行充值。",
    rechargeDurationTip: "充值时长仅能由学员服务中心操作。",
    rechargeSuccess: "充值成功",
    rechargeUniversalDuration: "充值通用时长",
    recognitionCount: "识别次数",
    refreshFailed: "刷新失败",
    region: "区域",
    reinspectionResult404: "复检结果",
    rejectReason: "拒绝原因：",
    rejectReasonPlaceholder: "如拒绝，需要输入拒绝原因，内容会反馈至待转入学员。50字以内",
    remainingPayment457: "剩余支付金额",
    remainingRechargeableDuration: "剩余可充时长",
    remark: "备注:",
    remarkColumn: "备注",
    removeConfirmDesc: "移出后，将无法继续对学员进行督学和订阅相关服务。",
    removeConfirmSuffix: "移出服务中心吗？",
    removeConfirmTip: "确定要将学员",
    removeFromServiceCenter: "移出服务中心",
    renew: "自动续费",
    renewalReminder: "学习机续订提醒",
    renewAreaTypeConfirm: "您选择的续订时长类型为区域，续订后因常用地与认证区域不一致，将无法直接使用，确定续订此类型吗？",
    renewDurationTypeLabel: "续订时长类型:",
    renewMonthLabel: "续订月份:",
    renewPriceRuleNotExist: "未配置续订价格规则",
    renqu: "当前认证区域",
    repairFirstVisitAgreeLabel: "同意",
    repairFirstVisitCaptureMediaLabel: "拍摄图片视频",
    repairFirstVisitDescLabel: "初诊说明",
    repairFirstVisitDescPlaceholder: "请输入初诊说明，400字以内",
    repairFirstVisitExpectedTimeLabel: "预计完成时间",
    repairFirstVisitFactoryExpressInfoLabel: "返厂快递信息",
    repairFirstVisitLocalUploadLabel: "本地文件上传",
    repairFirstVisitMediaLabel: "初诊图片视频",
    repairFirstVisitMethodLabel: "初诊处理方式",
    repairFirstVisitPleaseSelectMethod: "请选择初诊处理方式",
    repairFirstVisitPleaseSelectSuggestedMethod: "请选择建议处理方式",
    repairFirstVisitReadFaultDescLabel: "阅读故障说明",
    repairFirstVisitRejectLabel: "驳回",
    repairFirstVisitResultLabel: "初诊结果",
    repairFirstVisitSaveLabel: "保存",
    repairFirstVisitSuggestedMethodLabel: "建议处理方式",
    repairFirstVisitUploadMediaLabel: "上传图片视频",
    repairOrders: "个维修单",
    repairPayment: "维修支付",
    repairPayment399: "维修支付",
    repairQuotationActualFaultTypeLabel: "实际故障类型",
    repairQuotationActualMethodLabel: "实际处理方式",
    repairQuotationAddDetailLabel: "添加维修明细",
    repairQuotationAmountLabel: "维修金额",
    repairQuotationCategoryLabel: "维修类别",
    repairQuotationCustomDiscountLabel: "自定义优惠金额",
    repairQuotationDeleteLabel: "删除",
    repairQuotationDescPlaceholder: "请输入报价说明，400字以内",
    repairQuotationDescriptionLabel: "描述文字",
    repairQuotationDescTitleLabel: "报价说明",
    repairQuotationDetailLabel: "维修明细",
    repairQuotationFaultImagesLabel: "故障图片:",
    repairQuotationFillResultLabel: "填写结果",
    repairQuotationNonWarrantyReasonLabel: "非保修原因",
    repairQuotationOperationLabel: "操作",
    repairQuotationPleaseAddDetail: "请添加维修明细",
    repairQuotationPleaseSelectActualMethod: "请选择实际处理方式",
    repairQuotationPleaseSelectFaultClass: "请选择故障分类",
    repairQuotationSerialNoLabel: "序号",
    repairQuotationTotalAmountLabel: "维修金额合计",
    repairQuotationUploadImageLabel: "上传图片",
    repairRejected: "已经拒修",
    repairRequest392: "维修申请",
    reportDate: "报告生成日期",
    reportType: "报告类型",
    reportWeekStartDate: "统计周起始日期",
    resend: "重新发送",
    resendAfterSeconds: "{n} 秒后重新发送",
    resendAfterSecondsTip: "秒后重新发送",
    responsibleStudentCount: "负责学生数",
    retakeCount: "重学次数",
    reTime: "重新时间",
    returnExpress402: "回寄快递",
    returnExpressNoLabel: "回寄快递",
    returnFactoryExpress: "返厂快递",
    returnFactoryExpress395: "返厂快递",
    returnFactoryFailed: "返厂快递操作失败",
    returnFactorySuccess: "返厂快递操作成功",
    review394: "审核",
    reviewStatus: "复盘状态",
    reviewTime: "复盘时间",
    san: "高三",
    sanyear: "三年级",
    save: "保存",
    save11: "保存",
    saveFailed: "保存失败",
    saveSuccess: "保存成功",
    school: "学校：",
    schoolOptionTip: "如选项中没有您要选择的学校，请联系总部支持人员进行反馈！",
    scmAccountMgmtAccountStatusFilterLabel: "账号状态：",
    scmAccountMgmtAccountStatusFilterPlaceholder: "请输入账号状态",
    scmAccountMgmtActivateDateLabel: "账号激活日期",
    scmAccountMgmtCertAreaPlaceholder: "请选择省份/市",
    scmAccountMgmtMachineAccountPlaceholder: "请输入学习机账户",
    scmAccountMgmtSnPlaceholder: "请输入SN码",
    scmAccountMgmtStudentSearchPlaceholder: "请输入学员账号、学员姓名",
    scmAccountMgmtSubAuthFilterPlaceholder: "请选择账户状态",
    scmSubAuthAlready: "已授权",
    scmSubAuthIng: "授权中",
    scmSubAuthNot: "未授权",
    search: "搜索学员:",
    searchAnalyst: "搜索分析师",
    searchAnalystLabel: "搜索分析师：",
    searchStudent: "搜索学员",
    searchStudentLabel: "搜索学员：",
    searchUser: "搜索用户",
    sec: "秒后自动关闭",
    sectionName: "课次名称",
    selectDate: "选择日期",
    selectDateTime: "选择日期时间",
    selectedCount: "已选{n}个",
    selectSchoolLabel: "选择学校:",
    selectStudentStep: "选择要申请的学员",
    selectStudentTip: "选择学员提示",
    selfStudyDate: "自学日期",
    sendVerifyCode: "发送验证码",
    serialNumber: "序号",
    serviceCenterId: "服务中心ID",
    serviceCenterId20: "服务中心ID",
    serviceCenterId39: "服务中心ID",
    serviceCenterIdLabel: "服务中心ID:",
    serviceCenterIdLower: "服务中心id",
    serviceCenterLabel: "服务中心",
    serviceCenterName: "服务中心名称",
    serviceCenterName21: "服务中心名称",
    serviceCenterName40: "服务中心名称",
    serviceCenterNameLabel: "服务中心名称:",
    serviceCenterSimple: "服务中心ID",
    serviceFollowUp: "服务跟进",
    servicePerson: "服务人员",
    servicePerson265: "服务人员",
    servicePerson305: "服务人员",
    servicePersonLabel: "服务人员：",
    servicePriceLabel: "服务价格：",
    shang: "维修厂商",
    sheng: "生物",
    showSampleAccount: "同时显示样机账号",
    shu: "视频数",
    shuoming: "详细说明",
    shuxue: "数学",
    siyear: "四年级",
    slotTipStyleColorRedFontSize110: "张",
    snCode: "SN码",
    snCodeLabel: "SN码：",
    songuoSubscriptionCard: "松果订阅卡",
    source: "来源：",
    sourceLabel: "来源:",
    channelEnum12: "知识漏洞大体检",
    channelEnum6301: "转介绍",
    channelEnum6302: "公海池",
    channelEnum6303: "地推",
    channelEnum6304: "新媒体",
    channelEnum6305: "其他",
    channelEnum6306: "电邀",
    channelEnum6307: "直访",
    channelEnum6308: "营销活动",
    channelEnum6309: "案例库",
    channelEnum6310: "名片分享",
    stage: "阶段",
    stageGrade: "阶段年级：",
    stageGrade_6003001: "小学",
    stageGrade_6003002: "初中",
    stageGrade_6003003: "高中",
    stageGrade_6003004: "幼儿园",
    stageGrade_6003005: "通用",
    stageGrade_6004001: "一年级",
    stageGrade_6004002: "二年级",
    stageGrade_6004003: "三年级",
    stageGrade_6004004: "四年级",
    stageGrade_6004005: "五年级",
    stageGrade_6004006: "六年级",
    stageGrade_6004007: "七年级",
    stageGrade_6004008: "八年级",
    stageGrade_6004009: "九年级",
    stageGrade_6004010: "高一",
    stageGrade_6004011: "高二",
    stageGrade_6004012: "高三",
    stageGrade_6004013: "高四",
    stageGrade_6004020: "通用",
    stageGrade_6004023: "小班",
    stageGrade_6004024: "中班",
    stageGrade_6004025: "大班",
    stageGrade261: "阶段年级",
    stageGrade294: "阶段年级",
    stageGrade303: "阶段年级",
    stageGradeEditOnce: "阶段年级仅限修改一次",
    stageGradeLabel: "阶段年级:",
    startTime: "开始时间",
    statisticsDate: "统计日期",
    statsDateRange: "统计日期范围",
    statsPeriod: "统计周期",
    status: "状态",
    student: "学员账号科目",
    studentAccount: "账号",
    studentAccount18: "学员账号",
    studentAccount37: "学员账号",
    studentAccount45: "学员账号",
    studentAccountColon: "学员账号:",
    studentAccountLabel: "学员账号",
    studentEnglishName: "学员英文姓名",
    studentImproveAnalysisDataDescriptionTip: "数据更新频率是每日早上9点更新，如需了解数据定义，请前往帮助中心",
    studentImproveAnalysisExport: "学员提分效果个体分析",
    studentImproveAnalysisImportantRemind: "重要提醒:为了确保全年级成绩能够统一、公正地进行计算和比较，在统计近180天的平均提分数、近180天考试平均分以及近180天的成绩标准差之前，我们将对每位学员的考试成绩进行标准化的转换处理，使其统一为100分制。",
    studentLabel: "学员",
    studentName: "姓名",
    studentName19: "学员姓名",
    studentName38: "学员姓名",
    studentName40: "学生姓名",
    studentName46: "学员名称",
    studentNameColon: "学员姓名:",
    studentNameFormatTip: "学员姓名仅支持中文字、英文大小写字母和姓名分隔\"·\"",
    studentNameFormLabel: "学生姓名:",
    studentNameLabel: "学员姓名",
    studentNameLabelColon: "学员姓名：",
    studentNameOrAccount: "学员姓名/学员账号",
    studentRiskLevel: '风控等级',
    studentRiskLevelNormal: '常规',
    studentRiskLevelLight: '轻度风险',
    studentRiskLevelHeavy: '重度风险',
    studentRiskLevelExempt: '免检',
    pleaseSelectStudentRiskLevel: '请选择风控等级',
    lastUpdatedTime: '最后更新时间',
    studentNamePhone: "学员姓名/手机",
    studentNameStudyTimeReport: "学生姓名",
    studentServiceDurationTip: "学员的服务时长为{studentDays}天，不满足{requiredDays}天的要求，您无法为学员进行续订",
    studentTransferApply: "学员转入申请",
    studyCorrectRate: "学习正答率",
    studyCount: "第几次自学",
    studyDate: "学习日期",
    studyDays: "学习天数",
    studyDurationHours: "学习时长（时）",
    studyTimeNoLimit: "不限",
    subject: "学科",
    subject28: "科目",
    subjectiveScoreRate: "主观题得分率",
    subjectLabel: "学科：",
    subjectName: "科目",
    submit: "提交",
    submitFailed: "提交失败",
    submitInformation: "提交资料",
    submitInformation3: "提交资料",
    submitMaterial: "提交材料",
    submitMaterial33: "提交材料",
    submitSuccess: "提交成功",
    submittedDeviceRepairApplication: "您提交的设备维修申请",
    subscribe: "订阅",
    subscribe17: "订阅",
    subscribe7: "订阅",
    subscribeConfirm: "订阅确认",
    subscribeConfirm18: "订阅确认",
    subscribed: "已订阅",
    /** 学习机学科 subscribeStatus，与 util/subscribeStatusConfig.js 一致 */
    subscribeStatusUnsubscribing: "退订中",
    subscribeStatusUnsubscribed: "已退订",
    subscribeStatusRenewFailed: "续订失败",
    subscribedSubjects: "已订阅学科",
    subscribeDurationArea: "订阅时长区域",
    subscribeDurationMonths: "订阅时长月数",
    subscribeSubject: "订阅学科",
    subscribeSubject268: "订阅学科",
    subscribeSubjectManage: "订阅学科管理",
    subscribeSubjectManage1: "订阅学科管理",
    subscribeSubjectManage17: "订阅学科管理",
    subscriptionCancelDate: "最近订阅/取消订阅日期",
    subscriptionCardLabel: "订阅卡",
    subscriptionCardNo: "订阅卡卡号",
    subscriptionCardNoLabel: "订阅卡卡号:",
    subscriptionCardPassword: "订阅卡卡号密码",
    subscriptionCardPasswordLabel: "订阅卡卡号密码",
    subscriptionCardPasswordLabelColon: "订阅卡卡号密码:",
    subscriptionCardType: "订阅卡类型",
    subscriptionCardTypeLabel: "订阅卡类型:",
    subscriptionCardVerifySuccess: "订阅卡核销成功",
    subscriptionDurationLessThan3: "可用订阅时长≤3",
    subscriptionManagement: "订阅管理",
    subscriptionSubjectLabel: "本次订阅学科:",
    supervisorAccount: "督学账号",
    supervisorExpired: "督学到期",
    supervisorMark: "督学标记",
    supervisorNoSupervise: "不督学",
    supervisorNumOverTwo: "近180天提交2次以上成绩督学人数",
    supervisorOnlineOnly: "仅线上",
    supervisorShop: "门店",
    supervisorStatus: "督学状态",
    supervisorStudyRoom: "自习室",
    supervisorUnmarked: "未标记",
    supervisorValidDate: "督学有效期",
    syncCourse: "同步课正答率",
    syncCourseCorrectQuestionCount: "同步课正答数",
    syncCourseCorrectRate: "同步课正答率",
    syncCourseDuration: "同步课时长",
    syncCourseEffectiveDuration: "同步课有效时长",
    syncCourseStatus: "同步课状态",
    syncCourseStatus264: "同步课状态",
    syncCourseStudyDuration: "同步课程学习时长",
    syncCourseTotalQuestionCount: "同步课答题数",
    syncErrorCorrectionDuration: "同步错题订正时长",
    tabFollowRecord: "跟进记录",
    tabFullTimeDeclare: "全日制申报",
    tabGoldDetail: "金币明细",
    tabMachineSubscribe: "学习机订阅",
    tabServiceRelation: "服务人关系",
    tabSuperviseService: "督学服务",
    tabUserRecord: "用户记录",
    tabVideoCall: "视频通话",
    taskCardCompleteTime: "任务卡完成时间",
    taskCardName: "任务卡名称",
    teacherImproveAnalystLabel: "分析师",
    teacherImproveDdjBandHigh: "120小时以上",
    teacherImproveDdjBandLow: "低于60小时",
    teacherImproveDdjBandMid: "60-120小时",
    teacherImproveDdjValidHoursFull: "近180天打地基有效时长（单位：小时）",
    teacherImproveEnterDuration: "请输入时长",
    teacherImprovePleaseEnterAnalyst: "请输入分析师",
    teacherImprovePleaseSelectStatDay: "请选择统计日",
    teacherImprovePleaseSelectStatYear: "请选择统计年份",
    teacherImproveStatDay: "统计日",
    teacherImproveStatYear: "统计年份",
    teacherStatusAllocated: "已分配",
    teacherStatusNoLimit: "不限",
    teacherStatusPendingAllocate: "待分配",
    tempPassHeld: "临时通行证持有中",
    tempPassHeld284: "临时通行证持有中",
    tempPassType: "临时通行证类型",
    text0128: "页面填写您的快递信息",
    text02ok: "故障说明按钮禁用",
    text041r: "避免中途损坏",
    text08wg: "回寄说明：",
    text0dkm: "如漏寄了配件",
    text0kxb: "单位",
    text0nkv: "不作为产品最终判定结果",
    text0pnd: "那么",
    text0tih: "您提交的",
    text0twu: "支付信息",
    text0uhw: "使用微信支付",
    text0y39: "尊敬的合作伙伴：",
    text0z0g: "实际故障类型",
    text13p1: "审核说明:",
    text16i0: "我已知晓",
    text1a2b: "表格合并字段",
    text1b76: "质检",
    text1cd3: "物流单",
    text1e1u: "已经完成付款",
    text1fdw: "督学师",
    text1gih: "初诊提醒",
    text1nox: "天成绩稳定性",
    text1nv3: "质检",
    text214l: "维修金额合计",
    text2192: "图片预览",
    text23it: "整机换新",
    text23os: "那么",
    text26cj: "超出了",
    text29kt: "页大小",
    text2af3: "纵向",
    text2cem: "通关证码",
    text2eo7: "老数据",
    text2fmi: "维修金额合计：",
    text2iu8: "保内维修",
    text2lb9: "当前页",
    text2obh: "默认选择",
    text2py7: "初诊说明",
    text2rn0: "非保修原因：",
    text2us2: "快递公司",
    text2v3y: "实际故障类型：",
    text2vll: "保外维修需要收取维修费用",
    text2vpv: "厂商地址",
    text303b: "请选择学科",
    text358v: "设置默认参数",
    text3alh: "区域",
    text3bv7: "获取",
    text3d7q: "全部状态表格列",
    text3dfv: "联系人：",
    text3ehe: "建议处理方式",
    text3gqv: "回寄图片",
    text3x2u: "客户电话：",
    text3yj8: "页面查看维修报价详情，并",
    text3zas: "维修详情数据",
    text3zgs: "大小",
    text41ik: "客户姓名：",
    text428g: "返修厂商:",
    text458z: "英语",
    text46ll: "视频视频",
    text498v: "您提交的的设备维修申请",
    text49ly: "支付说明",
    text4dse: "关闭故障说明弹框",
    text4dwa: "邮寄后请在",
    text4g8p: "您提交的的设备维修申请",
    text4h32: "复检备注",
    text4hjl: "复检结果：",
    text4kta: "弹窗将在",
    text4q11: "维修金额",
    text4sjg: "当前元素是否超出当前页",
    text4u2y: "或者更换了搜索条件",
    text4w53: "填写报价单",
    text4xfy: "表单增加",
    text4y7a: "订单状态",
    text583c: "设备经过厂商诊断",
    text58ht: "建议处理方式:",
    text5cxk: "信息如下",
    text5jeq: "由于保外维修需要收取维修费用",
    text5k7h: "争议结果：",
    text5kpp: "化学",
    text5lbq: "地理",
    text5mne: "生物",
    text5ogt: "返厂快递",
    text5pai: "初诊图片",
    text5s9o: "否则都应为默认的",
    text5sdf: "天提交",
    text5stz: "流转记录",
    text5tkq: "表格数据查询",
    text5x7e: "需要将整套机器",
    text60d9: "您提交的",
    text615b: "支持信用卡支付",
    text638k: "复检备注：",
    text63rq: "表格数据",
    text646e: "维修管理",
    text69ag: "返厂快递",
    text6cgu: "争议说明",
    text6kvt: "故障说明弹窗",
    text6of5: "维修明细：",
    text6psd: "联系地址：",
    text6qhb: "机器",
    text6rmc: "动态切割",
    text6sgg: "保外维修需要收取维修费用",
    text6vg3: "返回页码",
    text6vs3: "厂商退换货",
    text6xfh: "已经完成质检",
    text744d: "设备经过厂商诊断需要进行保外维修",
    text7457: "学科",
    text759t: "保外维修",
    text75jj: "数字转大写",
    text75l0: "原机不修返回",
    text7gjz: "视频通话记录",
    text7gkh: "回寄信息",
    text7m03: "故障说明",
    text7urb: "和维修支付弹框",
    text7wcs: "如寄了其他快递公司的到付",
    text7z8o: "前端先写死",
    text82m7: "所以这个必须设置为",
    text82n2: "获取未保修的原因",
    text84k1: "维修支付",
    text84xf: "都设置为默认的",
    text8av1: "或者更换了搜索条件",
    text8cva: "请选择人员",
    text8me7: "返厂的机器或配件请包装好",
    text8mih: "报价结果：",
    text8pgz: "暂无持有中通行证",
    text8qc9: "必填项初始化使用",
    text8ri1: "待提交",
    text8sol: "页面查看维修报价详情",
    text8uqq: "快递公司名称",
    text8xie: "长期",
    text8xvz: "复检结果",
    text8zqy: "维修管理",
    text8zt7: "切换跟进选项",
    text97nv: "仅适用",
    text98yq: "媒体为图片",
    text9aw1: "需要换新寄回",
    text9hs6: "测试",
    text9i1t: "非保修原因",
    text9j44: "厂商退换货",
    text9jj5: "或者是手动置空之后点击搜索",
    text9lhk: "化学",
    text9lns: "服务中心",
    text9m6j: "折叠",
    text9shl: "由于保外维修需要收取维修费用",
    text9tad: "售后地址",
    text9uwa: "生物",
    texta2iq: "或者是手动置空之后点击搜索",
    texta79g: "实际故障类型：",
    texta8dx: "申请",
    textabwu: "回寄快递信息：",
    textad7l: "非保修产品维修报价单",
    textaiqt: "取消维修待退回",
    textajcd: "客户提交的",
    textako6: "设置请求参数",
    textango: "快递要求",
    textapja: "打地基效果",
    textaspy: "检测说明",
    textauck: "优惠金额：",
    textavdq: "同步课正答率",
    textb067: "报价说明",
    textb2tm: "理由",
    textb31s: "已付款维修中",
    textb635: "尊敬的合作伙伴",
    textbbne: "暂无快递信息",
    textbcwr: "维修金额",
    textbdlq: "表格数据查询",
    textblwy: "维修结果",
    textbmh3: "感谢您的配合",
    textbxrg: "审核",
    textc6fo: "当前",
    textc8ye: "费用将需您自行承担",
    textcczt: "获取",
    textckrt: "报价说明",
    textclba: "返修厂商",
    textclfy: "返厂快递信息：",
    textcoch: "学生申请",
    textcos4: "非保修原因",
    textcovx: "确认人签名：",
    textcpyy: "造成物品损坏自行付费维修",
    textcu1q: "请选择学科",
    textcwbf: "短期",
    textcx7z: "初诊结果",
    textcz90: "修改",
    textd124: "所有配件以及包材",
    textd4ip: "维修支付",
    textd8ty: "获取故障类型",
    textdiws: "检测说明",
    textdjs3: "集合",
    textdkbb: "已过期",
    textdsln: "争议结果",
    textdt32: "修管理",
    textduw5: "不再弹",
    textdv5x: "修管理",
    textdxc4: "维修申请和返场快递提醒",
    texte0hp: "查看图片",
    texte27e: "点击清空按钮",
    texte2as: "感谢您的配合",
    texte4o5: "返回的物流信息",
    texte6z6: "维修结果：",
    textee6v: "争议",
    texteeeh: "不接受顺丰以外的到付",
    textefhh: "数学",
    texteg6t: "注意事项：",
    texteifo: "表格列表展示字段",
    textekrr: "质检说明：",
    texteusc: "导出参数",
    texteveb: "取消订阅",
    textew1u: "那么",
    textew8e: "回寄快递信息",
    textf2fv: "初诊处理方式：",
    textf2wp: "选择是否付款",
    textf35y: "个设备维修申请",
    textf6jv: "回寄结果：",
    textf6yk: "待验证",
    textf954: "维修结果",
    textf9ay: "历史搜索参数",
    textfb1f: "发放",
    textfe65: "售后维修提醒",
    textfea8: "根据比例计算需要打印的文件的总高度",
    textfgwm: "质检通过待寄回",
    textfhfk: "英语",
    textfl9n: "保存并支付",
    textfotn: "设备经过厂商诊断需要进行保外维修",
    textfrqk: "类名为",
    textfvoj: "未审核",
    textfwit: "纸总高度",
    textfy7i: "科学",
    textfz2w: "故障图片",
    textg052: "新机",
    textg4ij: "初诊说明：",
    textg6c0: "请您在",
    textg735: "维修类别",
    textg9iq: "设备经过厂商诊断",
    textgbp2: "售后维修提醒",
    textgbzr: "由于",
    textge5g: "确认人签名",
    textgkhx: "返厂快递",
    textgosk: "通过",
    textgr7g: "取消订阅",
    textgrxx: "为证明未通过",
    textgtjd: "推荐使用微信支付",
    textgwdb: "检测",
    textgyac: "横向",
    textgzgy: "故障图片",
    texth07c: "报价结果",
    texth1uz: "个设备维修申请",
    texth5tk: "感谢您的配合",
    texth8j6: "否则原机将认为不维修",
    texthayb: "没数据不弹框",
    texthed3: "产品外观进行的初步判定",
    texthf21: "实际处理方式：",
    texthfjq: "单位",
    texthgap: "商品类型",
    texthqio: "回寄说明",
    texthr60: "取消订阅",
    texthsad: "天成绩标准差",
    texthsjt: "语文",
    texthsuv: "操作类型",
    texthxic: "答题数",
    texti0by: "当前遍历的元素处于第几页",
    texti4n0: "取消订阅",
    texti7uy: "由于",
    texticu2: "点击清空按钮",
    textig4p: "获取数据",
    textijzk: "通用弹框",
    textikaf: "立即评价",
    textikvr: "维修明细",
    textir0j: "用于初始化必填项",
    textislp: "取消订阅",
    textitx4: "谢谢",
    textixqc: "已经审核通过",
    textjaby: "人脸基准照片",
    textjd4h: "未超出",
    textjeoq: "尊敬的合作伙伴",
    textjsfe: "导出的",
    textjxax: "需要重新寄出",
    textk7qh: "审核",
    textk916: "图片",
    textk9y5: "尊敬的总部人员",
    textkfxg: "人工跟进",
    textkgfd: "全部",
    textki4i: "流转记录",
    textkir1: "联系电话：",
    textkkko: "是否跨越了",
    textkltr: "初诊提醒：",
    textkot6: "创建",
    textkpx4: "回寄快递信息",
    textkqio: "都设置为默认的",
    textkscu: "查询物流状态",
    textkwff: "维修支付",
    textl5vr: "原价合计",
    textla63: "维修金额合计：",
    textlfnm: "您提交的设备维修申请",
    textlglu: "维修支付",
    textli61: "注意事项",
    textll3j: "同步课答对数",
    textlou3: "新数据",
    textlrf8: "人员",
    textlw09: "科学",
    textlw5h: "单位",
    textlw91: "待审核",
    textlzqa: "质检说明",
    textm0p2: "表格数据查询",
    textm3wt: "发放原因",
    textm4v8: "视频",
    textm6u6: "回调函数",
    textmem9: "对应的快递费需要您自行承担",
    textmgy6: "换新待寄回",
    textmije: "已经拒修",
    textmiye: "学科",
    textmku1: "维修明细：",
    textmmg0: "点击清空按钮",
    textmnjq: "或者更换了搜索条件",
    textmp23: "故障图片：",
    textmq6j: "折叠",
    textmqah: "实际处理方式",
    textmqmr: "售后地址",
    textmt4o: "来源类型",
    textmtn7: "回寄快递",
    textmtsi: "学科",
    textmwny: "维修申请",
    textn1kz: "报价单",
    textn6rk: "当做",
    textn8jo: "回寄信息",
    textnd2i: "否则都应为默认的",
    textnlkg: "维修明细",
    textno8d: "表格字段",
    textnp6g: "客户电话",
    textnqvz: "质检图片",
    textnsn7: "收件人信息：",
    textnuvo: "联系方式",
    textnv37: "初诊结果：",
    textnwkk: "中获取搜索参数",
    textnxhz: "页面查看维修报价详情",
    textny49: "如果搜索条件为空",
    texto0ao: "检测结果：",
    texto2a1: "控制跟进记录弹窗",
    texto2nu: "实际故障类型",
    texto7f9: "非保修原因：",
    texto91d: "全部状态表格列",
    textocqw: "则使用历史搜索条件",
    textocuo: "如有异议",
    textod5b: "表格总数",
    textoetj: "审核结果:",
    textoh1d: "逾期不取机将另行处理",
    texton15: "复检",
    textoq1w: "计算它是否超出所在",
    textoxa7: "学生姓名",
    textoxlo: "您提交的",
    textoy9p: "原价合计：",
    textp08s: "我维修中心为您免费保管",
    textp434: "邮寄后请在",
    textp5mv: "服务中心",
    textp6kc: "构建请求参数",
    textp709: "回寄结果",
    textp9nw: "天打地基攻克知识漏洞数",
    textpc7n: "数字转大写",
    textpcmy: "数学",
    textphoc: "个维修单",
    textphxg: "已通关",
    textpllk: "售后人员将加速为您处理",
    textpo0j: "维修中",
    textpoh2: "检测图片",
    textppwi: "地理",
    textpq7v: "返厂快递信息",
    textpsj3: "点了导出",
    textpth9: "表格标题",
    textpycm: "否则都应为默认的",
    textpyte: "否则都应为默认的",
    textpzwi: "故障书名是否已读",
    textq7tb: "联系地址",
    textq803: "最新",
    textqda5: "联系方式",
    textqefr: "需要进行保外维修",
    textqgtm: "计算当前",
    textqj07: "厂商退换货",
    textqm88: "质检状态",
    textqvas: "争议说明：",
    textqyyc: "审核状态",
    textqz8y: "收件人信息",
    textqzt0: "维修说明：",
    textr00k: "维修金额原价",
    textr1cq: "将退回原维修款",
    textr1hc: "展开",
    textr1ni: "维修中",
    textr8sg: "立即处理",
    textrab9: "取到要打印的",
    textrbae: "故障图片：",
    textrbki: "报告",
    textreh6: "如果为空",
    textrg6y: "您提交的设备维修申请",
    textrj1v: "实际处理方式",
    textrjax: "需要进行保外维修",
    textrnzc: "自定义弹框提醒",
    textropu: "报价说明：",
    textrv31: "持有中",
    textrvkf: "初诊处理方式",
    texts2sr: "或者是手动置空之后点击搜索",
    texts5d7: "获取数据",
    texts6oz: "并选择是否付款",
    texts82f: "故障类型",
    texts9rp: "学员近",
    textsamb: "通行证",
    textseap: "检测说明：",
    textselj: "最终判定结果以维修人员实际检测结果为准",
    textsfmz: "表格列表展示字段",
    textsh0l: "售后维修提醒",
    textsh84: "初诊",
    textsqsh: "展示红色",
    textsrm2: "服务中心",
    textstfk: "同步课总答题数",
    textsuj7: "不同意维修",
    textsxey: "审核备注",
    textt0rw: "判断条件",
    textt1am: "请在",
    textt2ff: "选择是否付款",
    textt4uf: "或者是手动置空之后点击搜索",
    textt611: "回寄快递",
    textt813: "尊敬的合作伙伴：",
    textt9n0: "待录入",
    texttaxz: "获取维修详情",
    textth1j: "图片的类型和质量",
    texttllb: "维修评价",
    texttrgt: "弹窗将在",
    texttu61: "表格合并字段",
    texttzem: "质检状态：",
    textu5s2: "尊敬的合作伙伴：",
    textucfs: "支付结果：",
    textucpq: "如有异议",
    textuczq: "取消订阅",
    textuir4: "证明未通过",
    textunic: "如因包装不符合",
    textutm4: "回寄快递",
    textuw1i: "已经弹过",
    textv07h: "改变",
    textv3y4: "已经审核通过",
    textv4jl: "都设置为默认的",
    textvbaq: "那么",
    textvd87: "给家长处理方式",
    textvdb7: "低于",
    textvdzu: "数据的总长度",
    textves7: "初诊",
    textvfii: "搜索表单",
    textvflo: "数学",
    textvg1v: "表格数据查询",
    textvgmx: "整机换新",
    textvms0: "维修类别",
    textvo61: "天提交",
    textvocn: "是否配件",
    textvrvj: "初诊说明",
    textvs5i: "如果有",
    textvwq8: "宽高比例",
    textvx0u: "售后人员将加速为您处理",
    textvyzx: "页面填写您的快递信息",
    textw07v: "语文",
    textw3lc: "选择基础保价",
    textw58a: "取消订阅",
    textw84m: "售后人员将加速为您处理",
    textw8lj: "返厂快递",
    textwa43: "请您在",
    textwaad: "维修进度",
    textwdoz: "厂商地址：",
    textwf3j: "检测",
    textwhs5: "搜索条件列",
    textwih6: "检测结果",
    textwj2j: "复检结果",
    textwjxd: "信息如下",
    textwo1j: "维修报价单",
    textwrja: "默认",
    textwzxq: "同意维修",
    textx02y: "采购金额：",
    textx3h1: "报价说明：",
    textx3li: "在正常质保内的机器请顺丰到付",
    textx66h: "点击清空按钮",
    textx6cv: "顶部文案提示",
    textx89t: "数据的总长度",
    textxa7k: "都设置为默认的",
    textxaqy: "维修管理",
    textxeb0: "联系电话",
    textxefe: "个设备维修申请",
    textxmip: "学员基本信息",
    textxngk: "但不承担其他责任",
    textxo9n: "流转记录:",
    textxqpu: "加载失败",
    textxqvc: "如果过期请联系经销商或者客服重新下载文件",
    textxwh2: "弹窗将在",
    texty0vr: "每页大小",
    texty3cr: "暂无已过期通行证",
    texty880: "外边距",
    texty8st: "维修说明",
    textycff: "物理",
    textyfdy: "搜索条件列",
    textyo22: "维修金额合计",
    textyt4i: "物理",
    textywfr: "根据",
    textywx2: "支付结果",
    textz14c: "系统跟进",
    textz2l6: "豆兆彬",
    textz2yr: "建议处理方式",
    textz8e2: "请求头中的验证信息等",
    textzc0w: "数据的总长度",
    textzc96: "或者更换了搜索条件",
    textzcvk: "支付说明：",
    textzefb: "开启故障说明",
    textzfvb: "展开",
    textzk14: "联系方式",
    textzk3n: "争议结果",
    textzunm: "并选择是否付款",
    textzzes: "轨迹",
    thankYouForYourCooperation: "感谢您的配合，售后人员将加速为您处理！",
    thisDeductDuration22: "本次扣除订阅时长",
    thisReturnDuration23: "本次返还订阅时长",
    thisSubscribeSubject20: "本次订阅学科",
    thisUnsubscribeSubject21: "本次退订学科",
    threeStarCount: "3星人科数",
    time: "操作时间",
    tipDuplicateApply: "以下学员已申请或正在支付证书，不可重复提交，请修改选择。",
    to: "至",
    topicEndTime: "专题结束时间",
    topicName: "专题名称",
    topicStartTime: "专题开始时间",
    totalDuration: "总时长",
    totalDurationHours: "汇总时长(小时)",
    totalQuestionCount: "总答题数",
    totalQuestionTime: "答题总时长",
    twoStarCount: "2星人科数",
    type: "操作类型",
    unbind2: "解绑",
    unbindConfirmTip: "确定要将 {account} 从学习机上解绑吗？解绑后，此账号不可继续使用学习机学习，已订阅的学科立刻失效。",
    unbindFailed: "解绑失败",
    unbindRelation: "解绑关系",
    unbindSuccess: "解绑成功",
    underRepair400: "维修中",
    unfreeze: "解冻",
    unfreezeSuccess: "账户解冻成功",
    universalAvailableDurationLabel: "通用可用学习时长:",
    universalBalance: "通用订阅时长（赠送或续费）余额",
    universalBalanceLabel: "通用时长余额:",
    universalDurationBalance: "通用时长余额",
    universalDurationRecharge: "通用时长充值",
    unstudyDays: "未学习天数",
    unsubscribe: "退订",
    unsubscribe16: "退订",
    unsubscribe6: "退订",
    unsubscribeConfirm19: "取消订阅",
    unsubscribeEffective: "退订生效",
    unsubscribeEffective5: "退订生效",
    unsubscribeEffective8: "退订生效",
    unsubscribeFailed: "退订失败",
    unsubscribeSuccess: "退订成功",
    uploadCountLimit9: "上传图片/视频大小不能超过 9个!",
    uploadFail: "上传失败",
    uploadFailRetry: "上传失败，请重试",
    uploadLimit10Images: "上传数量已达到上限，最多只能上传10张图片",
    uploadLimit9Images: "上传数量已达到上限，最多只能上传9张图片",
    uploadLimitError: "上传数量已达到上限，最多只能上传9张图片",
    uploadLimitReached: "上传数量已达上限",
    uploadMediaMax9Count: "上传图片/视频大小不能超过 9个!",
    uploadMediaSizeExceed20M: "上传图片/视频大小不能超过 20MB!",
    uploadSizeLimit20MB: "上传图片/视频大小不能超过 20MB!",
    uploadTip: "只能上传jpg/png文件，且不超过500kb",
    use: "使用",
    useLandlineOutbound: "使用座机外呼",
    useMobileOutbound: "使用手机号外呼",
    user: "用户账号",
    userAccount: "用户账号",
    userActivityFlag: "是否用户活动",
    userLabel: "用户",
    userName: "用户姓名",
    userNameLabel: "用户姓名：",
    userPlaceholder: "用户姓名/联系方式",
    userProfile: "用户档案",
    validateFailedRetry: "校验失败，请重试",
    verifyCode: "验证码",
    verifyCodeLabel: "验证码:",
    verifyCodeRequired: "验证码不能为空",
    verifyCodeSendSuccess: "验证码发送成功",
    verifyFailed: "验证失败",
    verifyFailedBind: "验证失败，无法绑定学员账号",
    videoCallDialingTimeLabel: "拨打时间",
    videoCallDurationColon: "通话时长：",
    videoCallFollowPeopleLabel: "人员",
    videoCallFollowPeoplePlaceholder: "请选择人员",
    videoCallRecord: "视频通话记录",
    videoCashAccountLabel: "现金账户",
    videoCount: "视频数",
    videoDuration: "视频时长",
    videoPaymentMethodLabel: "支付方式",
    videoServiceDurationColon: "服务时长：",
    videoWatchTimeApprox: "视频观看时长（非精确）",
    week: "周",
    withdrawApplication4: "撤回申请",
    withdrawApplySuccess: "撤回申请成功",
    within100Chars: "100字以内",
    within500Chars: "500字以内",
    wu: "无需复盘",
    wuyear: "五年级",
    xinma: "新SN码",
    xue: "化学",
    xuema: "学习SN码",
    xueque: "学后正确率",
    xuexiao: "学校",
    year: "统计年份",
    yes: "是",
    yesRecognitionStatus: "认证状态",
    yi: "维修的一些信息",
    yici: "天最近一次考试成绩",
    yiciday: "最近一次考试日期",
    yimonthhour: "则默认为一个月时间",
    yiyear: "一年级",
    yongdi: "常用地",
    you: "页面填写您的快递信息、回寄信息。",
    youbackyou: "感谢您的配合，售后人员将加速为您处理！",
    youci: "您对本次维修服务满意吗？",
    youshi: "有效时长",
    yuan: "元",
    zeroStarCount: "无星级人科数",
    fullTimeUploadLimit: "图片最多上传 10 张，每张最大 8M，格式支持 jpg、png",
    fullTimeUploadKeyPage: "务必要上传协议中的关键页",
    fullTimeKeyPageStudentInfo: "1、学员的基本信息",
    fullTimeKeyPageStudyPeriod: "2、全日制学习的开始和结束时间、和填写不一致会被驳回",
    fullTimeKeyPageChargeInfo: "3、收费情况",
    zongshi: "答题总时长",
  }
};
